import Moment from 'moment';
import { genfunction } from 'helpers';

const { nodeNo, PaymentTypeID, CashlessTypeID, GiftCardTypeID, TransactionUserName,
    DonationProductID, TransactionFeeProductID, ApplyTransactionFee, Currency,
    ShowOrderItemPriceAs, EnableAlternateMerchantOnline, Merchant2TypeID, StreetAddressTypeID, UseFamilyJoinDateOnMembershipPackageEarlyRenewal, ApplyTransactionFeeForAlternateMerchant, AlternateMerchantTransactionFeeProductID } = window['runConfig'];

export default {
    GetMonths() {
        var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        return monthNames;
    },

    GetYears(numberofyears) {
        var years = [];
        var currentyear = new Date().getFullYear();
        for (let index = 0; index < numberofyears; index++) {
            years.push(currentyear + index)
        }
        return years;
    },

    ccyFormat(num) {
        return Currency + num.toFixed(2);
    },

    priceRow(qty, unit) {
        return qty * unit;
    },

    subproducttotal(products, cashless, donation, transactionfee, membershipPackages, gatickets, giftcards, orderProducts, donationProducts, altTransactionfee) {
    
        let totalDiscount = 0;
        let transFee = 0; 
        let membershipPackTotal = 0;
        let altTransFee = 0;
        products.map(product =>
            product.CouponItems.map(e => 
                totalDiscount += e.TotalAmount
        ));

        let producttotal = this.GetProductsTotalPrice(products).total;
        let gaticketstotal = gatickets ? gatickets.map(({ TotalAmount }) => TotalAmount).reduce((sum, i) => sum + i, 0) : 0;
        let cashlesstotal  = cashless ?  cashless.map(({ HoldAmount }) => HoldAmount).reduce((sum, i) => sum + i, 0) : 0;
        let giftcardstotal = giftcards ? giftcards.map(({ CartTotalAmount }) => CartTotalAmount).reduce((sum, i) => sum + i, 0) : 0;
        let orderProductsTotal    = this.getOrderProductsTotalPrice(orderProducts).total;
        let donationProductsTotal = donationProducts ? donationProducts.map(({ Amount }) => Amount).reduce((sum, i) => sum + i, 0) : 0;

        let runningProductsTotal = producttotal;

        if (giftcardstotal > 0) {
            runningProductsTotal += giftcardstotal;
        }
            
        runningProductsTotal = donation && donation.isdonationApplied ? runningProductsTotal + parseFloat(donation.price) : runningProductsTotal;

        if (membershipPackages && membershipPackages.length > 0) {
            membershipPackTotal = membershipPackages.map(({ TotalAmount }) => TotalAmount).reduce((sum, i) => sum + i, 0);

            membershipPackages[0].MembershipProducts && membershipPackages[0].MembershipProducts.map(m => {
                
                if (m.CouponCodeApplied && m.CouponCodeApplied.length > 0) {

                if (m.MembershipType === "AddOn" && m.Quantity > 0) {
                    totalDiscount += m.CouponCodeIncTax;
                } 
                else if (m.MembershipType === "Membership" && m.Users.length > 0) {

                    m.Users.map(u => {
                        totalDiscount += m.CouponCodeIncTax;
                    });
                  }
                }
            });
        }

        // ---------------- DUAL-MERCHANT FEE BASES WHEN ENABLED ----------------
        let merchant1Total = 0, merchant2Total = 0;
        const dualFeesOn = EnableAlternateMerchantOnline &&
            transactionfee && transactionfee.hasOwnProperty('ProductID')
            altTransactionfee && altTransactionfee.hasOwnProperty('ProductID')

        if (dualFeesOn) {
            const mt = this.subproducttotalMultiMerchant(products, cashless, donation, membershipPackages, gatickets, giftcards, orderProducts, donationProducts)

            if (mt) {
            merchant1Total = Math.max(0, mt.merchant1Total);
            merchant2Total = Math.max(0, mt.merchant2Total);
            }
        }

        // ===== Main merchant fee =====
        if (typeof ApplyTransactionFee !== "undefined" && ApplyTransactionFee &&
            transactionfee && transactionfee.hasOwnProperty('ProductID')) {

            if (transactionfee.Price > 0) {
            if (dualFeesOn) {
                const m1Base = merchant1Total;
                transFee = this.calculateFeeFromAmount(
                    transactionfee,
                    m1Base,
                    m1Base 
                );
            } else {
                const baseFixed =
                    (runningProductsTotal + membershipPackTotal + gaticketstotal + orderProductsTotal + donationProductsTotal)
                    - totalDiscount;

                const basePercent =
                    ((runningProductsTotal + membershipPackTotal + gaticketstotal + orderProductsTotal + donationProductsTotal)
                        - totalDiscount) - cashlesstotal;

                transFee = this.calculateFeeFromAmount(
                    transactionfee,
                    baseFixed,
                    basePercent
                );
            }

            }
        }

        // ===== Alternate merchant fee =====
        if (dualFeesOn) {
            if (altTransactionfee && altTransactionfee.Price > 0) {
                const m2Base = merchant2Total;
                altTransFee = this.calculateFeeFromAmount(
                    altTransactionfee,
                    m2Base,
                    m2Base
                );
            }
        }

        return parseFloat(((runningProductsTotal + membershipPackTotal + gaticketstotal + orderProductsTotal + donationProductsTotal+ transFee + altTransFee - totalDiscount) - cashlesstotal).toFixed(2));
    },

    subproducttotalMultiMerchant(products, cashless, donation, membershipPackages, gatickets, giftcards, orderProducts, donationProducts) {

            let totalObj = {
            merchant1Total: 0,
            merchant2Total: 0
        }; 

            totalObj.merchant1Total = this.calculateMerchantTotalsForSide(products, cashless, donation, membershipPackages, gatickets, giftcards, orderProducts, donationProducts, false)

            totalObj.merchant2Total = this.calculateMerchantTotalsForSide(products, cashless, donation, membershipPackages, gatickets, giftcards, orderProducts, donationProducts, true)

        return totalObj;
    },
    calculateMerchantTotalsForSide(products, cashless, donation, membershipPackages, gatickets, giftcards, orderProducts, donationProducts, useAlternate){
           
        let totalDiscount = 0;
        let transFee = 0;
        let membershipPackTotal = 0;
        products.filter(x => x.UseAlternateMerchant === useAlternate).map(product => (
                product.CouponItems.map(e =>
                    totalDiscount += e.TotalAmount
                )
            ));

        let producttotal = this.GetProductsTotalPrice(products.filter(x => x.UseAlternateMerchant === useAlternate)).total;
        let gaticketstotal = gatickets ? gatickets.filter(x => x.UseAlternateMerchantOnline === useAlternate).map(({ TotalAmount }) => TotalAmount).reduce((sum, i) => sum + i, 0) : 0;
        let cashlesstotal = cashless ? cashless.map(({ HoldAmount }) => HoldAmount).reduce((sum, i) => sum + i, 0) : 0;
        let giftcardstotal = giftcards ? giftcards.filter(x => x.UseAlternateMerchantOnline === useAlternate).map(({ CartTotalAmount }) => CartTotalAmount).reduce((sum, i) => sum + i, 0) : 0;
        let orderProductsTotal = this.getOrderProductsTotalPrice(orderProducts.filter(x => x.UseAlternateMerchant === useAlternate)).total;
        let donationProductsTotal = donationProducts ? donationProducts.filter(x => x.UseAlternateMerchantOnline === useAlternate).map(({ Amount }) => Amount).reduce((sum, i) => sum + i, 0) : 0;

            if (giftcardstotal > 0) {
                producttotal = producttotal + giftcardstotal;
            }

            producttotal = donation && donation.isdonationApplied && !donation.UseAlternateMerchantOnline? producttotal + parseFloat(donation.price) : producttotal;

            if (membershipPackages && membershipPackages.length > 0 && membershipPackages[0].UseAlternateMerchant === useAlternate) {
                membershipPackTotal = membershipPackages.map(({ TotalAmount }) => TotalAmount).reduce((sum, i) => sum + i, 0);

                membershipPackages[0].MembershipProducts && membershipPackages[0].MembershipProducts.map(m => {

                    if (m.CouponCodeApplied && m.CouponCodeApplied.length > 0) {

                        if (m.MembershipType == "AddOn" && m.Quantity > 0) {
                            totalDiscount += m.CouponCodeIncTax;
                        }
                        else if (m.MembershipType == "Membership" && m.Users.length > 0) {

                            m.Users.map(u => {
                                totalDiscount += m.CouponCodeIncTax;
                            })
                        }
                    }

                });

            }

        return parseFloat(((producttotal + membershipPackTotal + gaticketstotal + orderProductsTotal + donationProductsTotal + + transFee - totalDiscount) - cashlesstotal).toFixed(2));
    },

    calculateeventsamount(events) {
        events.forEach(event => {
            event.TicketAmount = 0;
            event.TaxAmount = 0;
            event.TotalAmount = 0;
            event.TourProducts.forEach(product => {
                if (product.PriceMatrix && product.PriceMatrix.length > 0) {
                    var itemp = (product.PriceMatrix[0].Price * product.Quantity);
                    var itemtax = 0;
                    var itemTAmount = 0;
                    product.PriceMatrix[0].Taxes.forEach(tax => {
                        if (tax.TaxIncluded == true) {
                            itemTAmount = Math.round((itemp / ((tax.TaxPercentage / 100) + 1)) * 100) / 100;
                            itemtax = Math.round((itemp - itemTAmount) * 100) / 100;
                        }
                        else {
                            itemTAmount = itemp;
                            if (tax.TaxPercentage > 0) {
                                itemtax += Math.round((itemTAmount * (tax.TaxPercentage / 100)) * 100) / 100;
                            }
                        }
                    });

                    product.IndividualPrice = product.PriceMatrix[0].Price;
                    product.ProductAmount = itemTAmount;
                    product.ProductTaxAmount = itemtax;
                    product.ProductTotalAmount = product.ProductAmount + product.ProductTaxAmount;
                    event.TicketAmount += itemTAmount;
                    event.TaxAmount += itemtax;
                    event.TotalAmount = Math.round((event.TicketAmount + event.TaxAmount) * 100) / 100;
                }

            });
        });

        return events;
    },
    convertEventstoTransaction(events, cashless, customerId, token, donation, transactionFee,membershipPackages, gatickets, isManageBooking, bookings, managebkngTicketsModify, refundType, additionalPayment, giftcards, bookingUDFS, orderProducts, showTransFee,donationProducts, enteredAmountToPay, alternateTransactionFee) {
        let transactions = [];
        let trans = {};

        let booking = bookings && bookings[0] ? bookings[0] : null;
        let payMultipleBookings = bookings && bookings.length > 1;

        if (refundType === "AdditionalPayment" && isManageBooking && booking) {
            trans.TransactionType = "Booking Payment";
        }

        trans.NodeNo = nodeNo;
        trans.CustomerID = customerId;
        trans.Username = TransactionUserName;
        trans.Products = [];
        trans.Payments = [];
        let index = 0;
        let totalAmount = 0;
        let merchant1Total = 0;
        let merchant2Total = 0;

    
        if (isManageBooking && booking && refundType !== "AdditionalPayment") {

            if (managebkngTicketsModify === false || refundType === "CancelBooking" || refundType === "CancelGiftCardRefund") {
            booking.BookingProducts.forEach((product) => {
                if (product.Quantity > 0) {

                let newp = this.MMBReturnProduct(++index, product, booking);

                let ReturnCouponAppliedQty = 0;
                if (managebkngTicketsModify === false && refundType !== "CancelBooking" && refundType !== "CancelGiftCardRefund") {
                    newp.BookingStatus = "Change Date / Time";

                    if (booking.BookingCoupons && booking.BookingCoupons.length > 0 && booking.BookingCoupons.filter(x => x.TourProductID === product.TourProductID).length > 0) {

                    let couponProd = booking.BookingCoupons.find(x => x.TourProductID === product.TourProductID);

                    if (couponProd) {

                        if (couponProd.TimesUsed < Math.abs(product.Quantity)) {
                        ReturnCouponAppliedQty = Math.abs(product.Quantity) - couponProd.TimesUsed;
                        newp.Quantity = -Math.abs(couponProd.TimesUsed);
                        }

                        newp.CouponCodeApplied = couponProd.CouponCodeApplied;

                        if (ReturnCouponAppliedQty > 0) {
                        //index = this.MMBReturnUniqueCoupinNonItems(ReturnCouponAppliedQty, newp, product, couponProd, index+1, trans);
                        this.MMBReturnUniqueCoupinNonItems(ReturnCouponAppliedQty, newp, product, couponProd, ++index, trans);
                        return;
                        }
                    }
                    }
                }

                if (refundType === "CancelBooking" || refundType === "CancelGiftCardRefund") {
                    newp.CancelBooking = true;
                }

                trans.Products.push(newp);
                }
            });
            }

            if (managebkngTicketsModify) {
            booking.BookingProducts.forEach((product) => {
                if (product.Quantity > 0 && product.hasOwnProperty('newQuantity') && product.Quantity !== product.newQuantity) {

                let newp = this.GetMMBModifyProduct(++index, product, booking);
                trans.Products.push(newp);
                }
            });
            }
        }

        events.forEach(event => {
            let prevTourEventID = 0;

            event.TourProducts.forEach((product) => {
            if (product.Quantity > 0) {

                let newp = {
                ProductLineNo: ++index,
                ProductID: product.PriceMatrix[0].ProductID,
                Quantity: product.Quantity,
                LinePriceExTax: product.ProductAmount,
                LinePriceTax: product.ProductTaxAmount,
                LinePriceIncTax: product.ProductTotalAmount,
                LinePaidExTax: genfunction.IsNotFullPay(event.PaymentOption) ? product.ProductSelectedAmount : product.ProductAmount,
                LinePaidTax: genfunction.IsNotFullPay(event.PaymentOption) ? product.ProductSelectedTaxAmount : product.ProductTaxAmount,
                LinePaidIncTax: genfunction.IsNotFullPay(event.PaymentOption) ? product.ProductSelectedTotalAmount : product.ProductTotalAmount,
                TourEventID: event.TourEventID,
                TourProductID: product.TourProductID,
                CostRateID: product.PriceMatrix[0].CostRateID,
                TourHoldRef: event.TourHoldRef,
                CouponCodeApplied: this.FindCouponCode(event, event.TourEventID, product.TourProductID, product.Quantity)
                };

                if (isManageBooking && booking && managebkngTicketsModify) {
                newp.TourEventID = booking.TourEventID;
                newp.BookingID = booking.BookingID;
                newp.BookingStatus = "Modify Tickets";
                }

                if (isManageBooking && booking && managebkngTicketsModify === false && refundType !== "CancelBooking") {
                newp.BookingID = booking.BookingID;
                }

                //Add Booking UDF's
                if (isManageBooking == false && prevTourEventID === 0 && newp.Quantity > 0 && newp.TourEventID > 0 && newp.LinePriceIncTax >= 0) {
                this.AddBookingUDFs(bookingUDFS, trans, newp, event.BookingTypeID);
                prevTourEventID++;
                }

                if (this.FindUniqueCoupon(event, event.TourEventID, product.TourProductID) && newp.Quantity > 1) {
                newp = this.UpdateUniqueCouponProduct(event, newp.TourEventID, newp);
                }

                totalAmount += newp.LinePriceIncTax;
                trans.Products.push(newp);
            }
            });

            if (event.CouponItems.length > 0) {

            event.CouponItems.forEach((coupon) => {

                let prod = Object.assign({}, trans.Products.filter(x => x.TourEventID == coupon.TourEventID
                && x.TourProductID == coupon.TourProductID)[0]);

                prod.ProductLineNo = ++index;

                if (coupon.isUniqueCoupon) {

                if (coupon.ProdQuantity - coupon.Quantity != 0 && coupon.Discount > 0) //coupon.Discount == 100
                {
                    if (coupon.isPercentage) {
                    trans.Products.push(genfunction.AddUniqueCouponItem(prod, coupon));
                    prod.ProductLineNo = ++index;
                    }
                }

                prod.CouponHoldRef = coupon.CouponHoldRef;
                }

                if ((coupon.isUniqueCoupon && coupon.Discount > 0) || coupon.isUniqueCoupon == false) //coupon.Discount == 100
                {
                prod.Quantity = coupon.Quantity;
                }

                prod.TourProductID = coupon.ApplyDiscountTourProductID;
                prod.TourProductName = coupon.ApplyDiscountTourProductName;
                prod.ProductID = coupon.ApplyDiscountProductID;
                prod.LinePriceExTax = -coupon.TicketAmount;
                prod.LinePriceTax = -coupon.TicketTax;
                prod.LinePriceIncTax = -coupon.TotalAmount;
                prod.LinePaidExTax = -coupon.TicketAmount;
                prod.LinePaidTax = -coupon.TicketTax;
                prod.LinePaidIncTax = -coupon.TotalAmount;
                prod.CouponCodeApplied = null;

                totalAmount -= coupon.TotalAmount;
                trans.Products.push(prod);
            });
            }
        });

        gatickets.forEach(tickets => {
            if (tickets.Quantity > 0) {
            let newp = {
                ProductLineNo: ++index,
                ProductID: tickets.ProductID,
                Quantity: tickets.Quantity,
                LinePriceExTax: tickets.TicketAmount,
                LinePriceTax: tickets.TaxAmount,
                LinePriceIncTax: tickets.TotalAmount,
                LinePaidExTax: tickets.TicketAmount,
                LinePaidTax: tickets.TaxAmount,
                LinePaidIncTax: tickets.TotalAmount,
                CouponCodeApplied: tickets.CouponCodeApplied
            };

            totalAmount += newp.LinePriceIncTax;
            trans.Products.push(newp);
            }
        });

        if (donationProducts && donationProducts.length > 0) {
            donationProducts.forEach(product => {
            let newp = {
                ProductLineNo: ++index,
                ProductID: product.ProductID,
                Quantity: 1,
                LinePriceExTax: product.Amount,
                LinePriceTax: 0,
                LinePriceIncTax: product.Amount,
                LinePaidExTax: product.Amount,
                LinePaidTax: 0,
                LinePaidIncTax: product.Amount,
                ProductNotes: product.ProductNotes ? product.ProductNotes : ""
            }
            trans.Products.push(newp);
            })
        }

        orderProducts.forEach((product) => {
            let newp = {
            ProductLineNo: ++index,
            ProductID: product.ProductID,
            Quantity: product.Quantity,
            LinePriceExTax: (product.PriceExTax * product.Quantity),
            LinePriceTax: (product.PriceTax * product.Quantity),
            LinePriceIncTax: (product.PriceIncTax * product.Quantity),
            LinePaidExTax: (product.PriceExTax * product.Quantity),
            LinePaidTax: (product.PriceTax * product.Quantity),
            LinePaidIncTax: (product.PriceIncTax * product.Quantity),
            ProductNotes: product.ProductNotes,
            };

            if (product.Options && product.Options.length > 0) {
            newp.Options = [];
            product.Options.forEach(option => {
                let optionProducts = option.Products.filter(x => x.IsSelected);
                optionProducts.forEach(optionProduct => {
                let newop = {
                    ProductLineNo: ++index,
                    ProductID: optionProduct.ProductID,
                    Quantity: product.Quantity,
                    LinePriceExTax: optionProduct.PriceExTax * product.Quantity,
                    LinePriceTax: optionProduct.PriceTax * product.Quantity,
                    LinePriceIncTax: optionProduct.PriceIncTax * product.Quantity,
                    LinePaidExTax: optionProduct.PriceExTax * product.Quantity,
                    LinePaidTax: optionProduct.PriceTax * product.Quantity,
                    LinePaidIncTax: optionProduct.PriceIncTax * product.Quantity
                }
                newp.Options.push(newop);
                });
            });
            }
            trans.Products.push(newp);
        });

    
        if (donation && donation.isdonationApplied) {
            let donationProd = {
            ProductLineNo: ++index,
            ProductID: DonationProductID,
            Quantity: 1,
            LinePriceExTax: parseFloat(donation.price),
            LinePriceTax: 0,
            LinePriceIncTax: parseFloat(donation.price),
            LinePaidExTax: parseFloat(donation.price),
            LinePaidTax: 0,
            LinePaidIncTax: parseFloat(donation.price)
            }
            trans.Products.push(donationProd);
        }

        // -------------------- Transaction fee (global calc ??? base) --------------------
        var transFee = 0;
        var transTax = 0;

        if (ApplyTransactionFee && showTransFee && transactionFee && transactionFee.hasOwnProperty('ProductID')) {

            let cashlesstotal = cashless.map(({ HoldAmount }) => HoldAmount).reduce((sum, i) => sum + i, 0);

            transFee = (refundType === "AdditionalPayment" || (refundType === "" && enteredAmountToPay > 0)) ? 
            this.Rounded(this.GetTransactionFeeForPartialPayment(transactionFee, enteredAmountToPay, cashlesstotal))
            : this.Rounded(this.GetTransactionFee(transactionFee, events, donation, cashless, membershipPackages, gatickets, giftcards, orderProducts, donationProducts));

            transTax = this.ApplyTransactionFeeTax(transactionFee, transFee);

            if (transactionFee.Taxes && transactionFee.Taxes[0] && transactionFee.Taxes[0].TaxIncluded) {
            transFee -= transTax;
            }
        }

        
        if (membershipPackages && membershipPackages.length > 0) {

            let primaryMemberStartDate = "";

            membershipPackages.forEach(memPack => {

            memPack.MembershipProducts.forEach(m => {

                if ((m.MembershipType === "AddOn" && m.Quantity > 0) || (m.MembershipType === "Membership" && m.Users && m.Users.length > 0)) {

                if (m.MembershipType === "Membership" && m.Users && m.Users.length > 0) {
                    m.Users.forEach(u => {

                    let startDate = "";

                    if (UseFamilyJoinDateOnMembershipPackageEarlyRenewal) {

                        if (u.isRenewal && u.isPrimaryMember) {

                        if (u.MembershipExpiryDate == "" || (Moment(u.MembershipExpiryDate).format('YYYY-MM-DDT00:00:00') < Moment(new Date()).format('YYYY-MM-DDT00:00:00'))) {
                            startDate = Moment(new Date()).format('YYYY-MM-DDT00:00:00');
                        }
                        else {
                            startDate = new Date(u.MembershipExpiryDate);
                            startDate.setDate(startDate.getDate() + 1);
                            startDate = Moment(startDate).format('YYYY-MM-DDT00:00:00');
                        }

                        primaryMemberStartDate = startDate;
                        }
                        else {

                        if (primaryMemberStartDate === "" || primaryMemberStartDate.trim().length < 1) {
                            startDate = Moment(new Date()).format('YYYY-MM-DDT00:00:00');
                        }
                        else {
                            startDate = primaryMemberStartDate;
                        }
                        }
                    }
                    else {

                        startDate = Moment(new Date()).format('YYYY-MM-DDT00:00:00');

                        if (u.isRenewal) {
                        if (u.MembershipExpiryDate == "" || (Moment(u.MembershipExpiryDate).format('YYYY-MM-DDT00:00:00') < Moment(new Date()).format('YYYY-MM-DDT00:00:00'))) {
                            startDate = Moment(new Date()).format('YYYY-MM-DDT00:00:00');
                        }
                        else {
                            startDate = new Date(u.MembershipExpiryDate);
                            startDate.setDate(startDate.getDate() + 1);
                            startDate = Moment(startDate).format('YYYY-MM-DDT00:00:00');
                        }
                        }
                    }

                    let memProd = {
                        ProductID: m.ProductID,
                        ProductLineNo: ++index,
                        Quantity: 1,
                        LinePriceExTax: m.SubTotal,
                        LinePriceTax: m.TotalTax,
                        LinePriceIncTax: m.TotalAmount,
                        LinePaidExTax: m.SubTotal,
                        LinePaidTax: m.TotalTax,
                        LinePaidIncTax: m.TotalAmount,
                        MembershipPackageID: memPack.MembershipPackageID,
                        MembershipStartDate: startDate,
                        MembershipExpiryDate: this.GetMembershipExpiryDate(new Date(startDate), m.MembershipDuration ? m.MembershipDuration.toLowerCase() : ""),
                        MemberCustomerID: u.isRenewal ? u.userNo : u.isPrimaryMember ? -1 : 0,
                        IsRenewal: u.isRenewal,
                        RenewedUniquePackageRef: u.UniquePackageRef
                    }

                    if (m.hasOwnProperty('CouponCodeApplied') && m.CouponCodeApplied.length > 0) {
                        memProd.LinePriceExTax = m.PriceAfterCoupon;
                        memProd.LinePriceTax = m.TaxAfterCoupon;
                        memProd.LinePriceIncTax = m.TotalAmountAfterCoupon;
                        memProd.LinePaidExTax = m.PriceAfterCoupon;
                        memProd.LinePaidTax = m.TaxAfterCoupon;
                        memProd.LinePaidIncTax = m.TotalAmountAfterCoupon;
                        memProd.CouponCodeApplied = m.CouponCodeApplied;
                        memProd.CouponDiscountExTax = m.CouponCodeExTax;
                        memProd.CouponDiscountTax = m.CouponCodeTax;
                        memProd.CouponDiscountIncTax = m.CouponCodeIncTax;

                        if (m.hasOwnProperty('ExtraMonths') && m.ExtraMonths !== undefined && m.ExtraMonths > 0) {
                        memProd.MembershipExpiryDate = this.GetMembershipExpiryDate(new Date(memProd.MembershipExpiryDate), m.ExtraMonths + " months");
                        }

                        if (m.hasOwnProperty('ExtraDays') && m.ExtraDays !== undefined && m.ExtraDays > 0) {
                        memProd.MembershipExpiryDate = this.GetMembershipExpiryDate(new Date(memProd.MembershipExpiryDate), (m.ExtraDays + 1) + " days");
                        }

                    }

                    trans.Products.push(memProd);
                    });
                }
                else {


                    let startDate = "";

                    if (m.isRenewPackage) {
                    startDate = new Date(m.LastMembershipExpiryDate);
                    startDate.setDate(startDate.getDate() + 1);
                    startDate = Moment(startDate).format('YYYY-MM-DDT00:00:00');
                    }
                    else {
                    startDate = Moment(new Date()).format('YYYY-MM-DDT00:00:00');
                    }

                    let memProd = {
                    ProductID: m.ProductID,
                    ProductLineNo: ++index,
                    Quantity: 1,
                    LinePriceExTax: m.SubTotal,
                    LinePriceTax: m.TotalTax,
                    LinePriceIncTax: m.TotalAmount,
                    MembershipPackageID: memPack.MembershipPackageID,
                    MembershipStartDate: startDate,
                    MembershipExpiryDate: this.GetMembershipExpiryDate(new Date(startDate), m.MembershipDuration ? m.MembershipDuration.toLowerCase() : ""),
                    MemberCustomerID: m.isRenewPackage ? -2 : -1,
                    IsRenewal: false,
                    RenewedUniquePackageRef: ''
                    }

                    if (m.hasOwnProperty('CouponCodeApplied') && m.CouponCodeApplied.length > 0) {
                    memProd.LinePriceExTax = m.PriceAfterCoupon;
                    memProd.LinePriceTax = m.TaxAfterCoupon;
                    memProd.LinePriceIncTax = m.TotalAmountAfterCoupon;
                    memProd.LinePaidExTax = m.PriceAfterCoupon;
                    memProd.LinePaidTax = m.TaxAfterCoupon;
                    memProd.LinePaidIncTax = m.TotalAmountAfterCoupon;
                    memProd.CouponCodeApplied = m.CouponCodeApplied;
                    memProd.CouponDiscountExTax = m.CouponCodeExTax;
                    memProd.CouponDiscountTax = m.CouponCodeTax;
                    memProd.CouponDiscountIncTax = m.CouponCodeIncTax;

                    if (m.hasOwnProperty('ExtraMonths') && m.ExtraMonths !== undefined && m.ExtraMonths > 0) {

                        memProd.MembershipExpiryDate = this.GetMembershipExpiryDate(new Date(memProd.MembershipExpiryDate), m.ExtraMonths + " months");
                    }

                    if (m.hasOwnProperty('ExtraDays') && m.ExtraDays !== undefined && m.ExtraDays > 0) {
                        memProd.MembershipExpiryDate = this.GetMembershipExpiryDate(new Date(memProd.MembershipExpiryDate), (m.ExtraDays + 1) + " days");
                    }
                    }

                    trans.Products.push(memProd);
                }

                }

            });

            });

        }

        // -------------------- Totals for payments --------------------
        let paymentLineNo = 1;
        totalAmount = this.subproducttotal(events, cashless, donation, (showTransFee ? transactionFee : null), membershipPackages, gatickets, giftcards, orderProducts, donationProducts);

        let isUseAlternateMerchant = booking && booking.hasOwnProperty('BookingID') ? booking.UseAlternateMerchant : null;

        if (EnableAlternateMerchantOnline && (orderProducts && orderProducts.length < 1)) {
            // exclude fee from item totals in dual-merchant mode for clarity
            const tfForTotals = null;

            let merchantTotalObj = isManageBooking
            ? genfunction.CalculateMultiMerchantTotalForMMB(events, cashless, tfForTotals, enteredAmountToPay, bookings)
            : this.CalculateMultiMerchantTotal(events, gatickets, membershipPackages, giftcards, donation, tfForTotals, cashless, donationProducts);

            if (merchantTotalObj) {
            merchant1Total = merchantTotalObj.merchant1Total;
            merchant2Total = merchantTotalObj.merchant2Total;
            }

            totalAmount = 0;
        }

        // -------------------- Special cases  --------------------
        let feeHandled = false;

        // CASE A: EAMO = true, ATF = false, ATF4Alt = false  -> single fee on whole basket, assign to ALT payments
        if (EnableAlternateMerchantOnline && (!orderProducts || orderProducts.length < 1)
            && !ApplyTransactionFee && !ApplyTransactionFeeForAlternateMerchant
            && showTransFee && transactionFee && transactionFee.ProductID) {

            const baseA = Math.max(0, merchant1Total) + Math.max(0, merchant2Total);
            let exA = transactionFee.PriceIsAPercentage ? this.Rounded((transactionFee.Price / 100) * baseA)
                                                        : this.Rounded(transactionFee.Price);
            let taxA = this.ApplyTransactionFeeTax(transactionFee, exA);
            if (transactionFee.Taxes && transactionFee.Taxes[0] && transactionFee.Taxes[0].TaxIncluded) {
            exA = this.Rounded(exA - taxA);
            }
            const incA = this.Rounded(exA + taxA);

            if (incA > 0) {
            trans.Products.push({
                ProductLineNo: ++index,
                ProductID: TransactionFeeProductID,
                Quantity: 1,
                LinePriceExTax: exA,
                LinePriceTax:  taxA,
                LinePriceIncTax: incA,
                LinePaidExTax: exA,
                LinePaidTax:  taxA,
                LinePaidIncTax: incA
            });
            merchant2Total = this.Rounded(merchant2Total + incA); // push fee to alternate
            feeHandled = true;
            }
        }

        // CASE B: EAMO = true, ATF = true, ATF4Alt = false  -> single fee on whole basket, assign to ALT payments
        if (!feeHandled &&
            EnableAlternateMerchantOnline && (!orderProducts || orderProducts.length < 1) &&
            ApplyTransactionFee && !ApplyTransactionFeeForAlternateMerchant &&
            showTransFee && transactionFee && transactionFee.ProductID) {

            const baseB = Math.max(0, merchant1Total) + Math.max(0, merchant2Total);
            let exB = transactionFee.PriceIsAPercentage ? this.Rounded((transactionFee.Price / 100) * baseB)
                                                        : this.Rounded(transactionFee.Price);
            let taxB = this.ApplyTransactionFeeTax(transactionFee, exB);
            if (transactionFee.Taxes && transactionFee.Taxes[0] && transactionFee.Taxes[0].TaxIncluded) {
            exB = this.Rounded(exB - taxB);
            }
            const incB = this.Rounded(exB + taxB);

            if (incB > 0) {
            trans.Products.push({
                ProductLineNo: ++index,
                ProductID: TransactionFeeProductID,
                Quantity: 1,
                LinePriceExTax: exB,
                LinePriceTax:  taxB,
                LinePriceIncTax: incB,
                LinePaidExTax: exB,
                LinePaidTax:  taxB,
                LinePaidIncTax: incB
            });
            merchant2Total = this.Rounded(merchant2Total + incB); // push fee to alternate
            feeHandled = true;
            }
        }

        // -------------------- Per-merchant fee computation (dual-merchant with alt fee enabled) --------------------
        const useAltFee =
            !!EnableAlternateMerchantOnline &&
            !!ApplyTransactionFeeForAlternateMerchant &&
            !!(alternateTransactionFee && alternateTransactionFee.ProductID) &&
            (!orderProducts || orderProducts.length < 1);

        let m1FeeEx = 0, m1FeeTax = 0, m1FeeInc = 0;
        let m2FeeEx = 0, m2FeeTax = 0, m2FeeInc = 0;

        if (!feeHandled && useAltFee && ApplyTransactionFee && showTransFee) {
            const m1Base = Math.max(0, merchant1Total);
            m1FeeEx = transactionFee.PriceIsAPercentage
            ? this.Rounded((transactionFee.Price / 100) * m1Base)
            : this.Rounded(transactionFee.Price);
            m1FeeTax = this.ApplyTransactionFeeTax(transactionFee, m1FeeEx);
            if (transactionFee.Taxes && transactionFee.Taxes[0] && transactionFee.Taxes[0].TaxIncluded) {
            m1FeeEx = this.Rounded(m1FeeEx - m1FeeTax);
            }
            m1FeeInc = this.Rounded(m1FeeEx + m1FeeTax);

            const m2Base = Math.max(0, merchant2Total);
            m2FeeEx = alternateTransactionFee.PriceIsAPercentage
            ? this.Rounded((alternateTransactionFee.Price / 100) * m2Base)
            : this.Rounded(alternateTransactionFee.Price);
            m2FeeTax = this.ApplyTransactionFeeTax(alternateTransactionFee, m2FeeEx);
            if (alternateTransactionFee.Taxes && alternateTransactionFee.Taxes[0] && alternateTransactionFee.TaxIncluded) {
            m2FeeEx = this.Rounded(m2FeeEx - m2FeeTax);
            }
            m2FeeInc = this.Rounded(m2FeeEx + m2FeeTax);

            transFee = this.Rounded(m1FeeEx + m2FeeEx);
            transTax = this.Rounded(m1FeeTax + m2FeeTax);
        }

        // -------------------- Build fee product lines  --------------------
        if (!feeHandled) {
            const feeIncTotal = this.Rounded(transFee + transTax);
            if (ApplyTransactionFee && showTransFee && transactionFee && transactionFee.hasOwnProperty('ProductID') && feeIncTotal > 0) {
            const dualMode = !!EnableAlternateMerchantOnline && (!orderProducts || orderProducts.length < 1);

            if (!dualMode) {
                // single merchant behavior
                trans.Products.push({
                ProductLineNo: ++index,
                ProductID: TransactionFeeProductID,
                Quantity: 1,
                LinePriceExTax: this.Rounded(transFee),
                LinePriceTax: transTax,
                LinePriceIncTax: feeIncTotal,
                LinePaidExTax: this.Rounded(transFee),
                LinePaidTax: transTax,
                LinePaidIncTax: feeIncTotal
                });
            } else {
                if (useAltFee) {
                // two explicit lines (both merchants)
                if (m1FeeInc !== 0) {
                    trans.Products.push({
                    ProductLineNo: ++index,
                    ProductID: TransactionFeeProductID,
                    Quantity: 1,
                    LinePriceExTax: m1FeeEx,
                    LinePriceTax:  m1FeeTax,
                    LinePriceIncTax: m1FeeInc,
                    LinePaidExTax: m1FeeEx,
                    LinePaidTax:  m1FeeTax,
                    LinePaidIncTax: m1FeeInc
                    });
                }
                if (m2FeeInc !== 0) {
                    trans.Products.push({
                    ProductLineNo: ++index,
                    ProductID: AlternateMerchantTransactionFeeProductID,
                    Quantity: 1,
                    LinePriceExTax: m2FeeEx,
                    LinePriceTax:  m2FeeTax,
                    LinePriceIncTax: m2FeeInc,
                    LinePaidExTax: m2FeeEx,
                    LinePaidTax:  m2FeeTax,
                    LinePaidIncTax: m2FeeInc
                    });
                }
                merchant1Total = this.Rounded(merchant1Total + m1FeeInc);
                merchant2Total = this.Rounded(merchant2Total + m2FeeInc);
                } else { 

                const totalAbs = Math.abs(merchant1Total) + Math.abs(merchant2Total);

                if (totalAbs <= 0) {
                    trans.Products.push({
                    ProductLineNo: ++index,
                    ProductID: TransactionFeeProductID,
                    Quantity: 1,
                    LinePriceExTax: this.Rounded(transFee),
                    LinePriceTax: transTax,
                    LinePriceIncTax: feeIncTotal,
                    LinePaidExTax: this.Rounded(transFee),
                    LinePaidTax: transTax,
                    LinePaidIncTax: feeIncTotal
                    });
                    merchant1Total = this.Rounded(merchant1Total + feeIncTotal);
                } else {
                    const ratioM1 = Math.abs(merchant1Total) / totalAbs;
                    let m1Inc = this.Rounded(feeIncTotal * ratioM1);
                    let m2Inc = this.Rounded(feeIncTotal - m1Inc);

                    const taxRatio = feeIncTotal > 0 ? (transTax / feeIncTotal) : 0;

                    const m1Tax = this.Rounded(m1Inc * taxRatio);
                    const m1Ex  = this.Rounded(m1Inc - m1Tax);

                    const m2Tax = this.Rounded(m2Inc * taxRatio);
                    const m2Ex  = this.Rounded(m2Inc - m2Tax);

                    if (m1Inc !== 0) {
                    trans.Products.push({
                        ProductLineNo: ++index,
                        ProductID: TransactionFeeProductID,
                        Quantity: 1,
                        LinePriceExTax: m1Ex,
                        LinePriceTax:  m1Tax,
                        LinePriceIncTax: m1Inc,
                        LinePaidExTax: m1Ex,
                        LinePaidTax:  m1Tax,
                        LinePaidIncTax: m1Inc
                    });
                    }

                    if (m2Inc !== 0) {
                    trans.Products.push({
                        ProductLineNo: ++index,
                        ProductID: AlternateMerchantTransactionFeeProductID,
                        Quantity: 1,
                        LinePriceExTax: m2Ex,
                        LinePriceTax:  m2Tax,
                        LinePriceIncTax: m2Inc,
                        LinePaidExTax: m2Ex,
                        LinePaidTax:  m2Tax,
                        LinePaidIncTax: m2Inc
                    });
                    }

                    merchant1Total = this.Rounded(merchant1Total + m1Inc);
                    merchant2Total = this.Rounded(merchant2Total + m2Inc);
                }
                }
            }
            }
        }

        if (isManageBooking && booking) {
            if (managebkngTicketsModify === false && refundType !== "AdditionalPayment" && !EnableAlternateMerchantOnline) {

            let totalPaid = 0;
            if (booking.BookingPayments && booking.BookingPayments.length > 0) {
                booking.BookingPayments.forEach(x => {
                totalPaid += x.PaymentAmount;
                })
            }

            totalAmount = parseFloat((totalAmount - totalPaid).toFixed(2));
            }

            if (managebkngTicketsModify && refundType !== "AdditionalPayment" && !EnableAlternateMerchantOnline) {

            let totalPaid = 0;

            if (trans.Products.filter(x => x.Quantity < 0 && x.BookingID > 0).length > 0) {
                totalPaid = trans.Products.filter(x => x.Quantity < 0 && x.BookingID > 0).map(({ LinePriceIncTax }) => LinePriceIncTax).reduce((sum, i) => sum + i, 0);
            }

            totalAmount -= Math.abs(totalPaid);
            }

            if ((refundType === "GiftCardRefund" || refundType === "CancelGiftCardRefund") && ((!EnableAlternateMerchantOnline && totalAmount < 0) || (EnableAlternateMerchantOnline && (merchant1Total < 0 || merchant2Total < 0)))) {

            let amount = EnableAlternateMerchantOnline ? (isUseAlternateMerchant === false ? merchant1Total : merchant2Total) : totalAmount;

            let giftcardProd = {
                ProductLineNo: trans.Products.length + 1,
                ProductID: GiftCardTypeID,
                Quantity: 1,
                LinePriceExTax: Math.abs(amount),
                LinePriceTax: 0,
                LinePriceIncTax: Math.abs(amount),
                LinePaidExTax: Math.abs(amount),
                LinePaidTax: 0,
                LinePaidIncTax: Math.abs(amount)
            }

            trans.Products.push(giftcardProd);
            }

            if (refundType === "AdditionalPayment") {

            if (payMultipleBookings) {

                bookings.forEach(booking => {

                let addpayment = {
                    ProductLineNo: trans.Products.length + 1,
                    BookingID: booking.BookingID,
                    LinePaidIncTax: booking.BalanceOwing
                }

                trans.Products.push(addpayment);
                });

            }
            else {

                let transFeeWithTax = transFee + transTax;
                let additionalPaymentWithoutTransactionFee = transFeeWithTax > 0 ? this.Rounded(additionalPayment - transFeeWithTax) :
                additionalPayment;

                let addpayment = {
                ProductLineNo: trans.Products.length + 1,
                BookingID: booking.BookingID,
                LinePaidIncTax: this.AddCashlessAndAdditionalPayment(cashless, additionalPaymentWithoutTransactionFee)
                }

                trans.Products.push(addpayment);
            }

            }
        }


        if (giftcards && giftcards.length > 0) {

            giftcards.filter(x => x.AddedToCart && x.CartTotalAmount > 0).map(gc => {

            let giftcardProd = {
                ProductLineNo: trans.Products.length + 1,
                ProductID: gc.ProductID,
                Quantity: gc.CartQty,
                LinePriceExTax: gc.CartTotalAmount,
                LinePriceTax: 0,
                LinePriceIncTax: gc.CartTotalAmount,
                LinePaidExTax: gc.CartTotalAmount,
                LinePaidTax: 0,
                LinePaidIncTax: gc.CartTotalAmount
            }

            trans.Products.push(giftcardProd);
            });
        }

        if (refundType === "" && enteredAmountToPay > 0 && showTransFee && managebkngTicketsModify === false) {
            totalAmount = additionalPayment;
        }

        if (EnableAlternateMerchantOnline === false || (orderProducts && orderProducts.length > 0)) {

            if ((totalAmount > 0 && !isManageBooking) ||
            (isManageBooking && booking && totalAmount !== 0 && !(refundType === "GiftCardRefund" || refundType === "CancelGiftCardRefund" || refundType === "AdditionalPayment"))) {
            let payment = {
                PaymentLineNo: paymentLineNo,
                PaymentTypeID: PaymentTypeID,
                PaymentAmount: totalAmount,
                CreditCardToken: token.token,
                CreditCardType: token.cardtype,
                CreditCardReference: token.token,
                CreditCardMaskedNumber: token.cardnumber
            };

            trans.Payments.push(payment);
            paymentLineNo++;
            }
        }

        if (EnableAlternateMerchantOnline && (orderProducts && orderProducts.length < 1)) {

            let paymentAmount = this.Rounded(merchant2Total + merchant1Total);

            if (!isManageBooking || (isManageBooking && (paymentAmount > 0 ||((refundType === 'CreditCardRefund' || refundType === 'CancelBooking') && paymentAmount < 0)
                || (refundType === "AdditionalPayment" && additionalPayment !== 0)) && (refundType !== "GiftCardRefund" && refundType !== "CancelGiftCardRefund"))) {

            if (merchant1Total > 0 || merchant1Total < 0) {
                let payment = {
                PaymentLineNo: paymentLineNo,
                PaymentTypeID: PaymentTypeID,
                PaymentAmount: merchant1Total,
                CreditCardToken: token.token,
                CreditCardType: token.cardtype,
                CreditCardReference: token.token,
                CreditCardMaskedNumber: token.cardnumber
                };

                trans.Payments.push(payment);
                paymentLineNo++;
            }

            if (merchant2Total > 0 || merchant2Total < 0) {
                let payment = {
                PaymentLineNo: paymentLineNo,
                PaymentTypeID: Merchant2TypeID,
                PaymentAmount: merchant2Total,
                CreditCardToken: token.token,
                CreditCardType: token.cardtype,
                CreditCardReference: token.token,
                CreditCardMaskedNumber: token.cardnumber
                };

                trans.Payments.push(payment);
                paymentLineNo++;
            }
            }
        }

        cashless.forEach(item => {
            let payment = {
            PaymentLineNo: paymentLineNo,
            PaymentTypeID: CashlessTypeID,
            PaymentAmount: item.HoldAmount,
            GiftcardNumber: item.GiftcardNo,
            GiftcardHoldRef: item.GiftcardHoldRef
            };
            trans.Payments.push(payment);
            paymentLineNo++
        });

            if (!EnableAlternateMerchantOnline && refundType === "AdditionalPayment" && additionalPayment > 0) {

                if (token.token.length > 0) {
                let additionalPay = {
                    PaymentLineNo: paymentLineNo,
                    PaymentTypeID: PaymentTypeID,
                    PaymentAmount: additionalPayment,
                    CreditCardToken: token.token,
                    CreditCardType: token.cardtype,
                    CreditCardReference: token.token,
                    CreditCardMaskedNumber: token.cardnumber && token.cardnumber.length > 0 ? token.cardnumber : ''
                };

                trans.Payments.push(additionalPay);
                paymentLineNo++
                }
            }

            transactions.push(trans);

        return transactions;
    },

    GetRandomGiftCard(length) {
        var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var result = '';
        for (var i = 0; i < length; i++) {
            result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
        }
        return result;
    },
    UpdateUniqueCouponProduct(event, eventID, product) {

        let prod = Object.assign({}, product);

        if (event.CouponItems.filter(x => x.TourEventID == eventID && x.TourProductID == product.TourProductID).length > 0) {
            let c = event.CouponItems.filter(x => x.TourEventID == eventID && x.TourProductID == product.TourProductID)[0];

            if (prod && c.isPercentage && c.Discount > 0 && c.ProdQuantity - c.Quantity != 0) //c.Discount == 100
            {
                prod.Quantity = c.isPercentage && c.Discount > 0 ? prod.Quantity - c.Quantity : prod.Quantity; //c.Discount == 100
                prod.LinePriceExTax = product.LinePriceExTax - c.TicketAmount;
                prod.LinePriceTax = product.LinePriceTax - c.TicketTax;
                prod.LinePriceIncTax = product.LinePriceIncTax - c.TotalAmount;
                prod.LinePaidExTax = prod.LinePriceExTax;
                prod.LinePaidTax = prod.LinePriceTax;
                prod.LinePaidIncTax = prod.LinePriceIncTax;
                prod.CouponCodeApplied = null;
            }
        }

        return prod;
    },
    FindCouponCode(event, eventID, prodID, prodQuantity) {

        if (event.CouponItems.filter(x => x.TourEventID == eventID && x.TourProductID == prodID
            && x.isUniqueCoupon == true && x.ProdQuantity == x.Quantity).length > 0) {
            return event.CouponItems.filter(x => x.TourEventID == eventID && x.TourProductID == prodID)[0].UniqueCouponCode;
        }

        if (event.CouponItems.filter(x => x.TourEventID == eventID && x.TourProductID == prodID
            && x.isUniqueCoupon == true && x.Discount != 100 && x.ProdQuantity > x.Quantity).length > 0) {
            return event.CouponItems.filter(x => x.TourEventID == eventID && x.TourProductID == prodID)[0].UniqueCouponCode;
        }

        if (event.CouponItems.filter(x => x.TourEventID == eventID && x.TourProductID == prodID
            && x.isUniqueCoupon == false).length > 0) {
            return event.CouponItems.filter(x => x.TourEventID == eventID && x.TourProductID == prodID)[0].CouponCode;
        }

        return null;
    },
    FindUniqueCoupon(event, eventID, prodID) {
        if (event.CouponItems.filter(x => x.TourEventID == eventID && x.TourProductID == prodID
            && x.isUniqueCoupon == true).length > 0) {
            return true;
        }

        return false;
    },
    AddUniqueCouponItem(product, coupon) {

        let prod = Object.assign({}, product);

        prod.Quantity = coupon.Quantity;
        prod.TourProductID = coupon.TourProductID;
        prod.TourProductName = coupon.TourProductName;
        prod.LinePriceExTax = coupon.TicketAmount;
        prod.LinePriceTax = coupon.TicketTax;
        prod.LinePriceIncTax = coupon.TotalAmount;
        prod.LinePaidExTax = coupon.TicketAmount;
        prod.LinePaidTax = coupon.TicketTax;
        prod.LinePaidIncTax = coupon.TotalAmount;
        prod.CouponCodeApplied = coupon.UniqueCouponCode;
        prod.CouponHoldRef = null;

        return prod;
    },

    GetTotalAmount(Products) {
        let totalInclTax = 0;
        let totalExclTax = 0;
        let totalTax = 0;

        Products.forEach(Product => {
            totalInclTax += Product.LinePaidIncTax;
            totalExclTax += Product.LinePaidExTax;
            totalTax += Product.LinePaidTax;
            if (Product.Options) {
                Product.Options.forEach(option => {
                    totalInclTax += option.LinePaidIncTax;
                    totalExclTax += option.LinePaidExTax;
                    totalTax += option.LinePaidTax;
                });
            }
        });

        return {
            totalInclTax: totalInclTax,
            totalExclTax: totalExclTax,
            totalTax: totalTax
        };
    },
    GetProdsTotalAmount(Products) {
        let totalInclTax = 0;
        let totalExclTax = 0;
        let totalTax = 0;

        Products && Products.forEach(Product => {
            totalInclTax += Product.LinePaidIncTax;
            totalExclTax += Product.LinePaidExTax;
            totalTax += Product.LinePaidTax;
        });

        let prodsTotal = Products && Products.map(({ LinePaidIncTax }) => LinePaidIncTax).reduce((sum, i) => sum + i, 0);

        if (prodsTotal === 0) {
            return {
                totalInclTax: 0,
                totalExclTax: 0,
                totalTax: 0
            };
        }


        return {
            totalInclTax: totalInclTax,
            totalExclTax: totalExclTax,
            totalTax: totalTax
        };
    },

    UpdateEvent(ExistingEvents, NewEvent, IsEditEvent) {
        let existEevent = ExistingEvents.filter(x => x.TourEventID == NewEvent.TourEventID)[0];

        var E = NewEvent.TourProducts.map(product => {

            if (existEevent.TourProducts.filter(x => x.TourProductID == product.TourProductID).length > 0) {
                let pQty = IsEditEvent ? parseInt(product.Quantity)
                    : parseInt(product.Quantity) + parseInt(existEevent.TourProducts.filter(x => x.TourProductID == product.TourProductID)[0].Quantity)

                product.Quantity = '';
                product.Quantity = pQty;

            }

            return product
        });

        existEevent.TourProducts.filter(e => e.Quantity > 0).map(prod => {

            if (!E.filter(x => x.TourProductID == prod.TourProductID).length > 0) {
                E.push(prod);
            }
        });

        NewEvent.TourProducts = [];
        NewEvent.TourProducts = E;

        //Update Coupons
        NewEvent.CouponItems = IsEditEvent ? [] : existEevent.CouponItems;

        return NewEvent;
    },

    GetUpdateClient(oldclient, newclient) {
        let objclient = {
            CustomerID: oldclient.CustomerID,
            FirstName: newclient.FirstName,
            LastName: newclient.LastName,
            CustomerAddress: [
                {
                    AddressID: oldclient.CustomerAddress.filter(x => x.Email && x.Email.toLowerCase() == newclient.CustomerAddress[0].Email.toLowerCase())[0].AddressID,
                    "IsPrimaryAddress": true,
                    "Email": newclient.CustomerAddress[0].Email,
                    "Street1": newclient.CustomerAddress[0].Street1,
                    "Street2": newclient.CustomerAddress[0].Street2,
                    "CitySuburb": newclient.CustomerAddress[0].CitySuburb,
                    "State": newclient.CustomerAddress[0].State,
                    "Postcode": newclient.CustomerAddress[0].Postcode,
                    "Country": newclient.CustomerAddress[0].Country
                }
            ]
        }
        return objclient;
    },

    GetEventDate(eventDate) {
        return Moment(eventDate).format('ddd MMMM DD YYYY')
    },
    GetEventDateReceiptFormat(eventDate) {
        return Moment(eventDate).format('dddd, MMMM Do YYYY, h:mm a')
    },
    AppendEndTime(eventDate) {
        return Moment(eventDate).format('h:mm a')
    },
    GetEventDateReceiptFormatwithoutTime(eventDate) {
        return Moment(eventDate).format('dddd, MMMM Do YYYY')
    },
    GetTransactionDate(tranDate) {
        return Moment(tranDate).format('ddd Do MMMM YYYY HH:mm A')
    },
    GetShortDateAndTime(tranDate) {
        return Moment(tranDate).format('DD MMMM YYYY HH:mm A')
    },
    AddToDateDate(calendarDate) {
        var new_date = Moment(calendarDate, "YYYY-MM-DD").add(6, 'days');
        var day = new_date.format('DD');
        var month = new_date.format('MM');
        var year = new_date.format('YYYY');

        return year + '-' + month + '-' + day;
    },
    AddToDateDate(calendarDate, ListViewSearchDays) {
        var new_date = Moment(calendarDate, "YYYY-MM-DD").add(ListViewSearchDays - 1, 'days');
        var day = new_date.format('DD');
        var month = new_date.format('MM');
        var year = new_date.format('YYYY');

        return year + '-' + month + '-' + day;
    },
    AddSevenDays(calendarDate) {
        var new_date = Moment(calendarDate, "YYYY-MM-DD").add(6, 'days');
        var day = new_date.format('DD');
        var month = new_date.format('MM');
        var year = new_date.format('YYYY');

        return year + '-' + month + '-' + day;
    },
    AddWeekDays(calendarDate) {
        var new_date = Moment(calendarDate, "YYYY-MM-DD").add(8, 'days');
        var day = new_date.format('DD');
        var month = new_date.format('MM');
        var year = new_date.format('YYYY');

        return year + '-' + month + '-' + day;
    },
    RemoveSevenDays(events, searchDays, date) {

        let nextDate = null;

        if (events && events.length > 0 && events != "no-content" && events != "nocontent") {
            nextDate = new Date(Math.min(...events.map(e => new Date(e.EventEndDateTime))));
        }

        var new_date = events === "no-content" || events === "nocontent" ? Moment(date, "YYYY-MM-DD").add(-searchDays, 'days') : Moment(nextDate, "YYYY-MM-DD").add(-searchDays, 'days');
        var day = new_date.format('DD');
        var month = new_date.format('MM');
        var year = new_date.format('YYYY');

        return year + '-' + month + '-' + day;
    },
    AddNextSevenDays(events) {

        let nextDate = null;

        if (events && events.length > 0 && events != "no-content" && events != "nocontent") {
            nextDate = new Date(Math.max(...events.map(e => new Date(e.EventEndDateTime))));
        }

        var new_date = Moment(nextDate, "YYYY-MM-DD").add(1, 'days');
        var day = new_date.format('DD');
        var month = new_date.format('MM');
        var year = new_date.format('YYYY');

        return year + '-' + month + '-' + day;
    },
    PaddingString(value, paddingchar, numofcharshown) {
        return value.toString().padStart(numofcharshown, paddingchar);
    },
    EncodeBase64(input) {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
        let str = input;
        let output = '';

        for (let block = 0, charCode, i = 0, map = chars;
            str.charAt(i | 0) || (map = '=', i % 1);
            output += map.charAt(63 & block >> 8 - i % 1 * 8)) {
            charCode = str.charCodeAt(i += 3 / 4);
            if (charCode > 0xFF) {
                console.log("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
            }
            block = block << 8 | charCode;
        }
        return output;
    },

    ConvertCartItemToTourHold(cartevent, newevent, isEditEvent) {

        let tourholds = [];
        if (cartevent && cartevent.length > 0) {
            cartevent.forEach(tourevent => {

                let tourhold = {
                    TourEventID: tourevent.TourEventID,
                    TourHoldRef: tourevent.TourHoldRef,
                    TourHolds: []
                }

                tourevent.TourProducts.forEach(product => {

                    let newProductQuantity = 0;
                    if (newevent.TourProducts.filter(p => p.TourProductID === product.TourProductID).length > 0) {
                        newProductQuantity = newevent.TourProducts.filter(p => p.TourProductID === product.TourProductID)[0].Quantity;
                    }

                    if (newProductQuantity > 0) {

                        let tourproduct = {
                            TourProductID: product.TourProductID,
                            Seats: product.Quantity
                        }
                        tourhold.TourHolds.push(tourproduct);
                    }
                });
                tourholds.push(tourhold);
            });
        }

        let toureventobj = tourholds.find(te => te.TourEventID == newevent.TourEventID);
        if (toureventobj) {
            newevent.TourProducts.forEach(product => {
                let tourproduct = toureventobj.TourHolds.find(tp => tp.TourProductID == product.TourProductID);
                if (tourproduct) {
                    isEditEvent ? tourproduct.Seats = product.Quantity : tourproduct.Seats += product.Quantity;
                }
                else {
                    let tourproduct = {
                        TourProductID: product.TourProductID,
                        Seats: product.Quantity
                    }
                    toureventobj.TourHolds.push(tourproduct);
                }
            })
        }
        else {
            let tourhold = {
                TourEventID: newevent.TourEventID,
                TourHolds: []
            }

            newevent.TourProducts.forEach(product => {
                let tourproduct = {
                    TourProductID: product.TourProductID,
                    Seats: product.Quantity
                }
                tourhold.TourHolds.push(tourproduct);

            });
            tourholds.push(tourhold);
        }
        return tourholds;
    },
    ConvertCartItemToTourHoldRemoveTourProduct(cartevent, toureventId, tourProductID) {
        let tourholds = [];
        if (cartevent && cartevent.length > 0) {
            cartevent.forEach(tourevent => {

                let tourhold = {
                    TourEventID: tourevent.TourEventID,
                    TourHoldRef: tourevent.TourHoldRef,
                    TourHolds: []
                }

                tourevent.TourProducts.forEach(product => {

                    if (tourevent.TourEventID == toureventId && product.TourProductID == tourProductID) {

                    }
                    else {
                        let tourproduct = {
                            TourProductID: product.TourProductID,
                            Seats: product.Quantity
                        }
                        tourhold.TourHolds.push(tourproduct);
                    }
                });

                tourholds.push(tourhold);
            });
        }
        return tourholds;
    },

    ConvertCartItemToTourHoldResetState(cartevent) {
        let tourholds = [];
        if (cartevent && cartevent.length > 0) {
            cartevent.forEach(tourevent => {

                let tourhold = {
                    TourEventID: tourevent.TourEventID,
                    TourHoldRef: tourevent.TourHoldRef,
                    TourHolds: []
                }

                tourholds.push(tourhold);
            });
        }
        return tourholds;
    },

    ConvertCartTourToTourHoldResetState(cartevent, TourEventID) {
        let tourholds = [];
        if (cartevent && cartevent.length > 0) {
            cartevent.filter(x => x.TourEventID == TourEventID).forEach(tourevent => {

                let tourhold = {
                    TourEventID: tourevent.TourEventID,
                    TourHoldRef: tourevent.TourHoldRef,
                    TourHolds: []
                }

                tourholds.push(tourhold);
            });
        }
        return tourholds;
    },
    ConvertCartItemToTourHoldIncreaseQuantity(cartevent, toureventId, tourProductID, quantity) {
        let tourholds = [];
        if (cartevent && cartevent.length > 0) {
            cartevent.forEach(tourevent => {

                let tourhold = {
                    TourEventID: tourevent.TourEventID,
                    TourHoldRef: tourevent.TourHoldRef,
                    TourHolds: []
                }

                tourevent.TourProducts.forEach(product => {
                    let qty = product.Quantity;
                    if (tourevent.TourEventID == toureventId && product.TourProductID == tourProductID) {
                        qty = quantity;
                    }
                    let tourproduct = {
                        TourProductID: product.TourProductID,
                        Seats: qty
                    }
                    tourhold.TourHolds.push(tourproduct);

                });
                tourholds.push(tourhold);
            });
        }
        return tourholds;
    },
    SetTourHoldRef(tourholds, newevent) {
        let toureventobj = tourholds.find(te => te.TourEventID == newevent.TourEventID);
        newevent.TourHoldRef = toureventobj.TourHoldRef;
        return newevent;
    },
    IsCouponExpiry(coupon) {
        return false;
    },
    GetGiftCardHoldRequest(giftcardno, amount) {
        return [
            {
                "GiftcardNo": giftcardno,
                "HoldAmount": amount,
                "AllowPartial": true
            }
        ]
    },
    GetGiftCardHoldRequestForUpdate(cashless) {
        let newcashless = cashless.map(item => {
            return {
                "GiftcardNo": item.GiftcardNo,
                "GiftcardHoldRef": item.GiftcardHoldRef,
                "HoldAmount": item.HoldAmount,
                "AllowPartial": true
            }
        })
        return newcashless;
    },
    RecalculatedCashlessArray(cashless, totalamount) {
        let sortedcashless = cashless.sort((a, b) => { return (a.HoldAmount + a.BalanceRemaining) - (b.HoldAmount + b.BalanceRemaining); });

        let amount = 0;
        let lastupdateflag = false;
        let newcashless = sortedcashless.map(item => {
            let giftcardtotalamount = item.HoldAmount + item.BalanceRemaining;
            if (item.BalanceRemaining == 0 && (amount + giftcardtotalamount) <= totalamount)
                item.state = 'Remain';
            else if (lastupdateflag == false && amount != totalamount) {
                item.state = 'Update';
                item.BalanceRemaining = giftcardtotalamount
                if (item.BalanceRemaining < totalamount - amount)
                    item.HoldAmount = item.BalanceRemaining;
                else
                    item.HoldAmount = totalamount - amount;
                item.BalanceRemaining -= item.HoldAmount;
                lastupdateflag = true;
            }
            else {
                item.state = 'Delete';
            }

            amount += item.HoldAmount + item.BalanceRemaining;
            return { ...item };
        });
        return newcashless;
    },
    maskGiftCardNo(giftCardNo) {

        if (giftCardNo.includes("--")) {
            giftCardNo = giftCardNo.split("--")[0];
        }
        const lastDigits = giftCardNo.slice(-6);
        const maskedNumber = lastDigits.padStart(giftCardNo.length, '*').slice(-10);
        return maskedNumber;
    },
    UniqueCouponApplied(couponItems, tourProductID, eventId) {

        if (couponItems && couponItems.length > 0) {
            if (couponItems.filter(x => x.TourProductID == tourProductID
                && x.TourEventID == eventId && x.isUniqueCoupon).length > 0) {
                return true;
            }
        }

        return false;
    },
    UpdateNewGiftCardHoldRef(oldCashlessarray, updatedCashless) {
        updatedCashless.forEach(newcashless => {
            let oldCashless = oldCashlessarray.find(old => old.GiftcardNo == newcashless.GiftcardNo)
            if (oldCashless)
                oldCashless.GiftcardHoldRef = newcashless.GiftcardHoldRef;
        })
        return oldCashlessarray;
    },
    replaceEscapeCharacters(item) {
        var itemValue = "";
        if (item && item.length > 0) {
            itemValue = item.split("\\r\\n").join("<br />");
            itemValue = itemValue.split("\\n").join("<br />");
            itemValue = itemValue.split("\\").join("");
        }
        return itemValue;
    },
    GetLatestTourEvent(events) {
        if (events.length == 1) {
            return events[0].EventStartDateTime;
        }
        else if (events.length > 1) {
            return events.reduce(function (a, b) { return a.EventStartDateTime > b.EventStartDateTime ? a.EventStartDateTime : b.EventStartDateTime; });
        }

        return new Date();
    },
    GetTourEventsList(events) {
        let eventsCollection = [];

        events.forEach(e => {
            eventsCollection.push(e.TourEventID);
        });

        return eventsCollection.toString();
    },
    ApplyMembershipPricesOnEvents(events, costrate, extraitems, DefaultCostRateID) {
        events.filter(e => e.OrganizationID === "").forEach(event => {
            event.TourProducts.map(product => {
                product.PriceMatrix = [];
                product.PriceMatrix.push(this.GetPriceMatrix(event.TourEventID, product.TourProductID, costrate, extraitems, DefaultCostRateID))
                return product;
            })
        });

        return this.calculateeventsamount(events);
    },
    ApplyMembershipPricesOnTourEvent(event, costrate, extraitems, DefaultCostRateID) {
        event.TourProducts.map(product => {
            product.PriceMatrix = [];
            product.PriceMatrix.push(this.GetPriceMatrix(event.TourEventID, product.TourProductID, costrate, extraitems, DefaultCostRateID))
            return product;
        });

        return event;
    },
    GetEvent(extraitems, toureventid) {
        return extraitems.find(x => x.TourEventID == toureventid)
    },
    GetPriceMatrix(eventID, prodID, costRateID, extraitems, DefaultCostRateID) {
        if (extraitems && extraitems.length > 0) {
            let extraItem = this.GetEvent(extraitems, eventID);
            let product = extraItem.TourProducts.filter(x => x.TourProductID == prodID);
            let pMatrix = [];
            if (product && product.length > 0) {
                if (product[0].PriceMatrix && product[0].PriceMatrix.find(x => x.CostRateID == costRateID)) {
                    return product[0].PriceMatrix.find(x => x.CostRateID == costRateID);
                }
                else if (product[0].PriceMatrix && product[0].PriceMatrix.find(x => x.CostRateID == DefaultCostRateID)) {
                    return product[0].PriceMatrix.find(x => x.CostRateID == DefaultCostRateID);
                }
            }
        }
    },
    CustomerPostCall(memberValidation, curentemail) {
        let emailMatch = false;
        let phoneMatch = false;
        let addressMatch = false;

        if (memberValidation.hasOwnProperty('EmailMatched')) {
            emailMatch = memberValidation.EmailMatched;
        }

        if (memberValidation.hasOwnProperty('EmailOnFile')) {
            if (emailMatch == false && memberValidation.EmailOnFile === curentemail) {
                emailMatch = true;
            }

            if (emailMatch == false && memberValidation.EmailOnFile !== curentemail) {
                emailMatch = false;
            }
        }

        if (memberValidation.hasOwnProperty('PhoneMatched')) {
            phoneMatch = memberValidation.PhoneMatched;
        }

        if (memberValidation.hasOwnProperty('AddressMatched')) {
            addressMatch = memberValidation.AddressMatched;
        }

        if (emailMatch && phoneMatch && addressMatch) {
            return false;
        }

        return true;
    },
    ValidateMemberValidate(membershipValidation) {

        if (membershipValidation) {

            let emailMatch = false;
            let phoneMatch = false;
            let addressMatch = false;

            if (membershipValidation.hasOwnProperty("EmailMatched")) {
                emailMatch = membershipValidation.EmailMatched;
            }

            if (membershipValidation.hasOwnProperty("PhoneMatched")) {
                phoneMatch = membershipValidation.PhoneMatched;
            }

            if (membershipValidation.hasOwnProperty("AddressMatched")) {
                addressMatch = membershipValidation.AddressMatched;
            }

            if (emailMatch || phoneMatch || addressMatch) {
                return true;
            }
        }

        return false;
    },
    RemoveUnUsedBookingTypes(bookingTypes, events) {

        bookingTypes.forEach(bt => {
            if (events.find(x => x.BookingTypeID === bt.BookingTypeID) === undefined) {
                bookingTypes = bookingTypes.filter(x => x.BookingTypeID !== bt.BookingTypeID);
            }
        });

        return bookingTypes;
    },
    TransactionFee( products, donation, transactionfee, cashless, membershipPackages, gatickets, giftcards, orderProducts, donationProducts, alternateTransactionfee) {

        // Dual-merchant fee mode? (main + alt)
        const dualFeesOn =EnableAlternateMerchantOnline &&
            transactionfee && transactionfee.hasOwnProperty('ProductID')
            alternateTransactionfee && alternateTransactionfee.hasOwnProperty('ProductID')

        if (dualFeesOn) {
        const mt = this.subproducttotalMultiMerchant(products, cashless, donation, membershipPackages, gatickets, giftcards, orderProducts, donationProducts)|| { merchant1Total: 0, merchant2Total: 0 }


            const m1Base = Math.max(0, mt.merchant1Total);
            const m2Base = Math.max(0, mt.merchant2Total);

            // main fee (ex) and tax
            let mainEx  = this.calculateBaseFee(transactionfee, m1Base);
            let mainTax = 0;
            if (mainEx > 0) {
            if (transactionfee.Taxes && transactionfee.Taxes[0]) {
                if (!transactionfee.Taxes[0].TaxIncluded) {
                mainTax = this.ApplyTransactionFeeTax(transactionfee, mainEx);
                } else {
                mainTax = 0;
                }
            }
            }

            // alt fee (ex) and tax
            let altEx  = this.calculateBaseFee(alternateTransactionfee, m2Base);
            let altTax = 0;
            if (altEx > 0) {
            if (alternateTransactionfee.Taxes && alternateTransactionfee.Taxes[0]) {
                if (!alternateTransactionfee.Taxes[0].TaxIncluded) {
                altTax = this.ApplyTransactionFeeTax(alternateTransactionfee, altEx);
                } else {
                altTax = 0;
                }
            }
            }

            return this.Rounded((mainEx + mainTax) + (altEx + altTax));
        }

        let tFee = this.GetTransactionFee(transactionfee, products, donation, cashless, membershipPackages, gatickets, giftcards, orderProducts, donationProducts);

        if (tFee > 0 && transactionfee.Taxes && transactionfee.Taxes[0] && !transactionfee.Taxes[0].TaxIncluded) {
            tFee += this.ApplyTransactionFeeTax(transactionfee, tFee);
        }

        return tFee;
    },
    GetTransactionFee(transactionfee, products, donation, cashless, membershipPackages, gatickets, giftcards, orderProducts, donationProducts, alternateTransactionfee) {

        const dualFeesOn =EnableAlternateMerchantOnline &&
            transactionfee && transactionfee.hasOwnProperty('ProductID')
            alternateTransactionfee && alternateTransactionfee.hasOwnProperty('ProductID')

        if (dualFeesOn) {
            return 0;
        }
            if (transactionfee && transactionfee.hasOwnProperty('ProductID')) {

                if (transactionfee.Price > 0) {

                    if (!transactionfee.PriceIsAPercentage) {
                        let cashlesstotal = cashless.map(({ HoldAmount }) => HoldAmount).reduce((sum, i) => sum + i, 0);
                        let transFee = (this.subproducttotal(products, cashless, donation, transactionfee, membershipPackages, gatickets, giftcards, orderProducts, donationProducts) * transactionfee.Price) / 100;
                        return cashlesstotal > 0 || transFee > 0 ? transactionfee.Price : 0;
                    }

                    return ((this.subproducttotal(products, cashless, donation, undefined, membershipPackages, gatickets, giftcards, orderProducts, donationProducts)) * transactionfee.Price) / 100;
                }
            }

            return 0;
    },
    calculateBaseFee(tFee, baseAmount) {
    if (!tFee || tFee.Price <= 0) return 0;

    if (!tFee.PriceIsAPercentage) {
        return baseAmount > 0 ? parseFloat(tFee.Price) : 0;
    }

    // Percentage of base
    return Math.round(parseFloat(baseAmount.toFixed(2)) * tFee.Price) / 100;
    },
    ApplyTransactionFeeTax(transactionfee, tFee) {
        if (transactionfee.Price > 0) {
            if (transactionfee.Taxes) {

                if (transactionfee.Taxes[0].TaxIncluded) {
                    let itemAmount = Math.round((tFee / ((transactionfee.Taxes[0].TaxPercentage / 100) + 1)) * 100) / 100;
                    return Math.round((tFee - itemAmount) * 100) / 100;
                }

                return Math.round((tFee * (transactionfee.Taxes[0].TaxPercentage / 100)) * 100) / 100;
            }
            return tFee;
        }

        return 0;
    },
    ReturnDateOnly(datetime) {
        let year = Moment(datetime).format('YYYY');
        let month = parseInt(Moment(datetime).format('M'));
        let date = Moment(datetime).format('DD');

        return new Date(year, month > 1 ? month - 1 : 0, date);
    },
    CalculateMembershipPackageTotal(membershipPackage) {
        let membershipProducts = membershipPackage.MembershipProducts;
        let MemPackTotals = {
            TaxTotal: 0,
            SubTotal: 0,
            TotalAmount: 0
        }

        if (membershipProducts) {
            membershipProducts.map(e => {

                if ((e.MembershipType === "AddOn" && (e.hasOwnProperty('Quantity') || e.hasOwnProperty('MinQuantity')) && (e.Quantity > 0 || e.MinQuantity > 0)) || (e.MembershipType === "Membership" && (e.Users !== undefined ? e.Users.length > 0 : false))) {

                    if (e.MinQuantity > 0 && e.Quantity == 0) {
                        e.Quantity = 1;
                    }

                    var itemp = e.MembershipType === "Membership" ? e.Price : (e.Price * e.Quantity);
                    var itemtax = 0;
                    var itemTAmount = 0;
                    var iterations = e.MembershipType === "Membership" ? e.Users.length : 1;
                    var i;

                    for (i = 0; i < iterations; i++) {

                        if (e.Taxes && e.Taxes.length > 0) {
                            e.Taxes.forEach(tax => {
                                if (tax.TaxIncluded == true) {
                                    itemTAmount = Math.round((itemp / ((tax.TaxPercentage / 100) + 1)) * 100) / 100;
                                    itemtax = Math.round((itemp - itemTAmount) * 100) / 100;
                                }
                                else if (tax.TaxIncluded == false) {
                                    itemTAmount = itemp;
                                    if (tax.TaxPercentage > 0) {
                                        itemtax = Math.round((itemTAmount * (tax.TaxPercentage / 100)) * 100) / 100;
                                    }
                                }
                                else {
                                    itemtax = 0;
                                    itemTAmount = itemp;
                                }
                            })
                        }
                        else {
                            itemtax = 0;
                            itemTAmount = itemp;
                        };

                        MemPackTotals.TaxTotal += itemtax;
                        MemPackTotals.SubTotal += itemTAmount;

                        MemPackTotals.TotalAmount = MemPackTotals.TaxTotal + MemPackTotals.SubTotal;
                    }

                }

            });
        }


        return MemPackTotals;
    },
    CalculateMembershipPackages(membershipPackages) {
        membershipPackages.forEach(memPack => {
            memPack.TotalTax = 0;
            memPack.SubTotal = 0;
            memPack.TotalAmount = 0;
            memPack.MembershipProducts.forEach(memType => {
                var itemp = memType.Price;
                var itemtax = 0;
                var itemTAmount = 0;
                var iterations = memType.MembershipType === "Membership" ? (memType.Users ? memType.Users.length : 0) : (memType.Quantity ? memType.Quantity : 0);
                var i;
                for (i = 0; i < iterations; i++) {

                    if (memType.Taxes && memType.Taxes.length > 0) {
                        memType.Taxes && memType.Taxes.forEach(tax => {
                            if (tax.TaxIncluded == true) {
                                itemTAmount = Math.round((itemp / ((tax.TaxPercentage / 100) + 1)) * 100) / 100;
                                itemtax = Math.round((itemp - itemTAmount) * 100) / 100;
                            }
                            else if (tax.TaxIncluded == false) {
                                itemTAmount = itemp;
                                if (tax.TaxPercentage > 0) {
                                    itemtax = Math.round((itemTAmount * (tax.TaxPercentage / 100)) * 100) / 100;
                                }
                            }
                            else {
                                itemtax = 0;
                                itemTAmount = itemp;
                            }
                        });
                    }
                    else {
                        itemtax = 0;
                        itemTAmount = itemp;
                    }

                    if (memType.MembershipType === "AddOn" && memType.hasOwnProperty('Quantity') && memType.Quantity == 0) {
                        itemtax = 0;
                        itemtax = 0;

                    }
                    memType.TotalTax = itemtax;
                    memType.SubTotal = itemTAmount;
                    memType.TotalAmount = memType.TotalTax + memType.SubTotal;

                    memPack.TotalTax += itemtax;
                    memPack.SubTotal += itemTAmount;
                    memPack.TotalAmount = memPack.TotalTax + memPack.SubTotal;
                }
            })
        })

        return membershipPackages;
    },
    GetCustomerList(membershipPackages, customerReq, customerObj, customerAddresses) {

        let customersList = [];
        let cstCollection = { customerList: [], customerRequest: {} }
        let objCst = customerObj.customer && customerObj.customer.length > 0 ? customerObj.customer[0] : null;

        membershipPackages.forEach(memPack => {

            memPack.MembershipProducts.forEach(memType => {

                if (memType.MembershipType === "Membership" && memType.Users && memType.Users.length > 0) {

                    memType.Users.forEach(u => {

                        if (u.isPrimaryMember === true) {
                            customerReq[0].DateOfBirth = (u.dob === "DOB" || u.dob === "" || u.dob === undefined || u.dob === null) ? null : u.dob;
                        }

                        else {
                            var client =
                            {
                                "FirstName": u.firstName,
                                "LastName": u.lastName,
                                "DateOfBirth": (u.dob === "DOB" || u.dob === "" || u.dob === undefined || u.dob === null) ? null : u.dob,
                                "Relationship": "",
                                "TransactionRight": null,
                                "AdministrationRight": null,
                                "CustomerAddress": [
                                    {
                                        "AddressID": this.GetSecondaryUserAddressID(u, customerAddresses),
                                        "Email": u.email,
                                        "MobilePhone": u.phone
                                    }
                                ]
                            };

                            if (objCst && objCst.hasOwnProperty('LinkedIndividuals') && objCst.LinkedIndividuals && objCst.LinkedIndividuals.length > 0) {
                                if (objCst.LinkedIndividuals.filter(x => x.CustomerID === u.userNo).length > 0) {

                                    let linkedMember = objCst.LinkedIndividuals.filter(x => x.CustomerID === u.userNo)[0];
                                    if (linkedMember) {
                                        client.CustomerID = linkedMember.CustomerID;
                                    }
                                }
                            }

                            customerReq[0].LinkedIndividuals.push(client);

                            var customer = {
                                user: client,
                                memPackID: memPack.MembershipPackageID,
                                memProdID: memType.ProductID,
                                userID: u.userNo
                            }

                            customersList.push(customer);
                        }
                    });

                }
            })
        })

        cstCollection.customerList = customersList;
        cstCollection.customerRequest = customerReq;

        return cstCollection;
    },
    AddYearsToDate(date, noOfYears) {
        return new Date(date.setFullYear(date.getFullYear() + noOfYears));
    },
    GetMembershipExpiryDate(date, datediff) {
        let noDiff = 0;
        let expiryDate = "";
        if (datediff && datediff.length > 0) {

            if (datediff.includes("years")) {
                noDiff = parseInt(datediff);
                expiryDate = Moment(date).add(noDiff, 'year');
            }
            else if (datediff.includes("months")) {
                noDiff = parseInt(datediff);
                expiryDate = Moment(date).add(noDiff, 'months');
            }
            else if (datediff.includes("days")) {
                noDiff = parseInt(datediff);
                expiryDate = Moment(date).add(noDiff, 'days');
            }
            else {
                expiryDate = Moment(new Date(datediff));
            }
        }

        return expiryDate.format('YYYY-MM-DDT00:00:00');
    },
    DaysInYear(year) {
        return ((year % 4 === 0 && year % 100 > 0) || year % 400 == 0) ? 366 : 365;
    },
    UpdateTransactionCall(customersList, transaction, customerResponse) {

        if (transaction && transaction[0].Products && transaction[0].Products.length > 0) {

            let priMember = transaction[0].Products.filter(x => x.MemberCustomerID == transaction[0].CustomerID && x.IsRenewal == true)[0];


            transaction[0].Products.forEach(p => {

                if (p.hasOwnProperty("MembershipPackageID") && p.hasOwnProperty("MemberCustomerID")) {

                    if (p.MemberCustomerID == -1 || p.MemberCustomerID == transaction[0].CustomerID) {
                        p.MemberCustomerID = transaction[0].CustomerID;
                    }
                    else if (priMember && priMember.IsRenewal && p.MemberCustomerID == -2) {
                        p.MemberCustomerID = transaction[0].CustomerID;
                        p.RenewedUniquePackageRef = priMember.RenewedUniquePackageRef;
                        p.IsRenewal = priMember.IsRenewal;
                    }
                    else {
                        var customer = customersList.filter(x => x.memPackID == p.MembershipPackageID && x.memProdID == p.ProductID)[0];

                        if (customer && customerResponse[0].LinkedIndividuals) {
                            var cst = customerResponse[0].LinkedIndividuals.filter(x => x.FirstName == customer.user.FirstName && x.LastName == customer.user.LastName)[0];

                            if (cst) {
                                p.MemberCustomerID = cst.CustomerID;
                                customersList = customersList.filter(x => x.userID != customer.userID);
                            }
                        } else {
                            p.MemberCustomerID = transaction[0].CustomerID;
                        }
                    }
                }

            })
        }

        return transaction;
    },
    calculategaticketamount(tickets) {
        tickets.forEach(ticket => {
            ticket.TicketAmount = 0;
            ticket.TaxAmount = 0;
            ticket.TotalAmount = 0;
            ticket.OriginalTicketAmount = 0;
            ticket.OriginalTaxAmount = 0;
            ticket.OriginalTotalAmount = 0;

            var itemp = (ticket.Price * ticket.Quantity);
            var itemtax = 0;
            var itemTAmount = 0;
            ticket.Taxes.forEach(tax => {
                if (tax.TaxIncluded == true) {
                    itemTAmount = Math.round((itemp / ((tax.TaxPercentage / 100) + 1)) * 100) / 100;
                    itemtax = Math.round((itemp - itemTAmount) * 100) / 100;
                }
                else {
                    itemTAmount = itemp;
                    if (tax.TaxPercentage > 0) {
                        itemtax += Math.round((itemTAmount * (tax.TaxPercentage / 100)) * 100) / 100;
                    }
                }
            });

            var originalitemp = (ticket.OriginalPrice * ticket.Quantity);
            var originalitemtax = 0;
            var originalitemTAmount = 0;
            ticket.Taxes.forEach(tax => {
                if (tax.TaxIncluded == true) {
                    originalitemTAmount = Math.round((originalitemp / ((tax.TaxPercentage / 100) + 1)) * 100) / 100;
                    originalitemtax = Math.round((originalitemp - originalitemTAmount) * 100) / 100;
                }
                else {
                    originalitemTAmount = originalitemp;
                    if (tax.TaxPercentage > 0) {
                        originalitemtax += Math.round((originalitemTAmount * (tax.TaxPercentage / 100)) * 100) / 100;
                    }
                }
            });
            ticket.TicketAmount += itemTAmount;
            ticket.TaxAmount += itemtax;
            ticket.TotalAmount = ticket.TicketAmount + ticket.TaxAmount;

            ticket.OriginalTicketAmount += originalitemTAmount;
            ticket.OriginalTaxAmount += originalitemtax;
            ticket.OriginalTotalAmount = ticket.OriginalTicketAmount + ticket.OriginalTaxAmount;
        });

        return tickets;
    },
    GetPrimaryMemberMembershipType(membershipPackage, memberMemberships) {
        let memberType = null;

        membershipPackage.MembershipProducts.map(memType => {

            if (memType.MembershipType === "Membership") {

                if (memberMemberships.filter(x => x.MembershipTypeID == memType.MembershipTypeID).length > 0) {
                    memberType = memberMemberships.filter(x => x.MembershipTypeID == memType.MembershipTypeID)[0];
                }
            }
        });

        return memberType;
    },
    GetValueIfObjectHasProperty(propertyName, obj) {
        let val = "";

        if (obj.hasOwnProperty(propertyName)) {
            val = obj[propertyName];
        }

        return val;
    },
    UpdateMembershipPackageForRenew(membershipPackage, membermemberships, customer) {

        let memberpackageDetails = {
            membershipPackage: {},
            userslist: []
        }

        let memMemberships = [];
        let primaryMemberType = {};



        if (customer && customer.length > 0 && membermemberships && membermemberships.Memberships.length > 0 && membermemberships.Memberships.filter(x => x.MembershipPackageID == membershipPackage.MembershipPackageID && x.IsCancelled == false && x.IsRenewed == false).length > 0) {

            memMemberships = membermemberships.Memberships.filter(x => x.MembershipPackageID == membershipPackage.MembershipPackageID && x.IsCancelled == false && x.IsRenewed == false); //[0]; //reverse()

            if (memMemberships && memMemberships.length > 0) {
                primaryMemberType = this.GetPrimaryMemberMembershipType(membershipPackage, memMemberships);
            }

            if (memMemberships && memMemberships.length > 0) {
                var user = {
                    isPrimaryMember: true,
                    popupTitle: 'Primary Member',
                    firstName: membermemberships.FirstName,
                    lastName: membermemberships.LastName,
                    email: membermemberships.Email,
                    dob: this.GetValueIfObjectHasProperty('DateOfBirth', customer[0]),
                    phone: this.GetValueIfObjectHasProperty('MobilePhone', customer[0].CustomerAddress[0]),
                    address1: this.GetValueIfObjectHasProperty('Street1', customer[0].CustomerAddress[0]),
                    address2: this.GetValueIfObjectHasProperty('Street2', customer[0].CustomerAddress[0]),
                    city: this.GetValueIfObjectHasProperty('CitySuburb', customer[0].CustomerAddress[0]),
                    state: this.GetValueIfObjectHasProperty('State', customer[0].CustomerAddress[0]),
                    zipcode: this.GetValueIfObjectHasProperty('Postcode', customer[0].CustomerAddress[0]),
                    country: this.GetValueIfObjectHasProperty('Country', customer[0].CustomerAddress[0]),
                    userNo: membermemberships.MemberNumber,
                    isRenewal: true,
                    isEdit: false,
                    membershipTypeID: primaryMemberType.MembershipTypeID,
                    membershipTypeName: primaryMemberType.ProductName,
                    PreviousMembershipType: primaryMemberType.ProductName,
                    notpartofPackage: false,
                    UniquePackageRef: primaryMemberType.UniquePackageRef,
                    MembershipExpiryDate: primaryMemberType.MembershipExpiryDate,
                    userSelectedFromDropdown: true
                }

                if (user.dob === '') {
                    user.dob = null;
                }

                memberpackageDetails.userslist.push(user);
            }


            if (membermemberships && membermemberships.LinkedIndividuals && membermemberships.LinkedIndividuals.length > 0) {

                membermemberships.LinkedIndividuals.map(mem => {

                    var linkedUser = customer[0].LinkedIndividuals.filter(x => x.CustomerID == mem.MemberNumber);

                    var user = {
                        isPrimaryMember: false,
                        firstName: mem.FirstName,
                        lastName: mem.LastName,
                        email: linkedUser && linkedUser.length > 0 && linkedUser[0].hasOwnProperty('Email') ? linkedUser[0].Email : '',
                        dob: mem.DateOfBirth === undefined || mem.DateOfBirth === '' ? null : mem.DateOfBirth,
                        phone: linkedUser && linkedUser.length > 0 && linkedUser[0].hasOwnProperty('MobilePhone') ? linkedUser[0].MobilePhone : '',
                        address1: '',
                        address2: '',
                        city: '',
                        state: '',
                        zipcode: '',
                        country: '',
                        userNo: mem.MemberNumber,
                        membershipTypeID: 0,
                        membershipTypeName: '',
                        previousMembershipType: '',
                        notpartofPackage: false,
                        isRenewal: true,
                        isEdit: false,
                        UniquePackageRef: '',
                        MembershipExpiryDate: '',
                        userSelectedFromDropdown: false
                    }

                    if (mem.Memberships && mem.Memberships.length > 0 && mem.Memberships.filter(x => x.MembershipPackageID == membershipPackage.MembershipPackageID && x.IsCancelled == false && x.IsRenewed == false && x.UniquePackageRef == primaryMemberType.UniquePackageRef).length > 0) {
                        mem.Memberships.filter(x => x.MembershipPackageID == membershipPackage.MembershipPackageID && x.IsCancelled == false && x.IsRenewed == false && x.UniquePackageRef == primaryMemberType.UniquePackageRef).map(m => {

                            user.membershipTypeID = m.MembershipTypeID;
                            user.UniquePackageRef = m.UniquePackageRef;
                            user.MembershipExpiryDate = m.MembershipExpiryDate;
                            user.PreviousMembershipType = m.ProductName;
                            user.membershipTypeName = m.ProductName;
                            memberpackageDetails.userslist.push(user);

                        });
                    } else {


                        if (memberpackageDetails.userslist.length > 0 && memberpackageDetails.userslist.filter(x => x.firstName == user.firstName && x.lastName == user.lastName).length == 0) {
                            user.notpartofPackage = true;

                            //Update Member with previous active membership details.

                            if (mem.Memberships && mem.Memberships.length > 0 && mem.Memberships.filter(x => x.IsCancelled == false && x.IsRenewed == false).length > 0) {

                                var mp = mem.Memberships.length > 0 && mem.Memberships.filter(x => x.IsCancelled == false && x.IsRenewed == false)[0];

                                if (mp) {
                                    user.membershipTypeID = mp.MembershipTypeID;
                                    user.UniquePackageRef = mp.UniquePackageRef;
                                    user.MembershipExpiryDate = mp.MembershipExpiryDate;
                                    user.PreviousMembershipType = mp.ProductName;
                                    user.membershipTypeName = mp.ProductName;
                                }
                            }

                            memberpackageDetails.userslist.push(user);
                        }

                    }

                });
            }
        }
        else {

            memberpackageDetails.membershipPackage = membershipPackage;
            return memberpackageDetails;
        }
        //Find List of users..
        membershipPackage.MembershipProducts = membershipPackage.MembershipProducts.map(memType => {

            if (memType.MembershipType === "Membership") {
                memType.Users = [];

                memberpackageDetails.userslist.filter(x => x.membershipTypeID == memType.MembershipTypeID && x.notpartofPackage === false).map(u => {
                    memType.Users.push(u);
                })
            }

            //Handle AddOns
            if (memType.MembershipType === "AddOn") {

                if (memMemberships.filter(x => x.MembershipTypeID == memType.MembershipTypeID).length > 0) {
                    memType.Quantity = 1;
                    memType.isRenewPackage = true;
                    memType.LastMembershipExpiryDate = memMemberships.filter(x => x.MembershipTypeID == memType.MembershipTypeID)[0].MembershipExpiryDate;
                }
                else {
                    memType.Quantity = 0;
                    memType.isRenewPackage = false;
                }
            }

            return memType;
        })

        memberpackageDetails.membershipPackage = membershipPackage;
        return memberpackageDetails;

    },
    ApplyMembershipCoupon(membershipPackageProds, membershipCoupon, couponCode) {

        membershipPackageProds = membershipPackageProds.map(m => {

            if (!(m.MembershipType == "AddOn" && m.Quantity == 0) && !(m.MembershipType == "Membership" && m.Users.length == 0)) {

                let membershipTypeDiscount = membershipCoupon.MembershipTypes.find(x => x.MembershipTypeID == m.MembershipTypeID);


                var itemtax = 0;
                var itemTAmount = 0;
                var memTotalTax = m.TotalTax ? m.TotalTax : 0;
                var memSubTotal = m.SubTotal ? m.SubTotal : 0;

                if (membershipTypeDiscount) {

                    m.CouponCodeExTax = 0;
                    m.CouponCodeTax = 0;
                    m.CouponCodeIncTax = 0;

                    if (membershipTypeDiscount.hasOwnProperty('DollarDiscountExTax')) {

                        if (m.TotalAmount >= membershipTypeDiscount.DollarDiscountIncTax && membershipTypeDiscount.DollarDiscountIncTax > 0) {

                            m.CouponCodeExTax = membershipTypeDiscount.DollarDiscountExTax;
                            m.CouponCodeTax = membershipTypeDiscount.DollarDiscountTax;
                            m.CouponCodeIncTax = membershipTypeDiscount.DollarDiscountIncTax;

                            itemTAmount = Math.round((memSubTotal - membershipTypeDiscount.DollarDiscountExTax) * 100) / 100;
                            itemtax = Math.round((memTotalTax - m.CouponCodeTax) * 100) / 100;
                        }
                        else {

                            itemTAmount = memSubTotal;
                            itemtax = memTotalTax;
                        }
                    }
                    else if (membershipTypeDiscount.hasOwnProperty('PercentageDiscount')) {

                        if (membershipTypeDiscount.PercentageDiscount > 0) {

                            m.CouponCodeExTax = parseFloat((Math.round((memSubTotal * ((membershipTypeDiscount.PercentageDiscount / 100))) * 100) / 100).toFixed(2));
                            m.CouponCodeTax = Math.round((memTotalTax * (membershipTypeDiscount.PercentageDiscount / 100)) * 100) / 100;
                            m.CouponCodeIncTax = Math.round((m.CouponCodeExTax + m.CouponCodeTax) * 100) / 100;

                            itemTAmount = Math.round((memSubTotal - m.CouponCodeExTax) * 100) / 100;
                            itemtax = Math.round((memTotalTax - m.CouponCodeTax) * 100) / 100;
                        }
                        else {

                            itemTAmount = memSubTotal;
                            itemtax = memTotalTax;
                        }
                    }

                    m.ExtraDays = membershipTypeDiscount.ExtraDays ? membershipTypeDiscount.ExtraDays : 0;
                    m.ExtraMonths = membershipTypeDiscount.ExtraMonths ? membershipTypeDiscount.ExtraMonths : 0;
                    m.CouponCodeApplied = couponCode;

                    if (!membershipTypeDiscount.hasOwnProperty('DollarDiscountExTax') && !membershipTypeDiscount.hasOwnProperty('PercentageDiscount')) {
                        m.PriceAfterCoupon = m.SubTotal;
                        m.TaxAfterCoupon = m.TotalTax;
                        m.TotalAmountAfterCoupon = m.TotalAmount;
                    }
                    else {
                        m.PriceAfterCoupon = itemTAmount;
                        m.TaxAfterCoupon = itemtax;
                        m.TotalAmountAfterCoupon = Math.round((itemTAmount + itemtax) * 100) / 100;
                    }

                    if (m.CouponCodeIncTax == 0 && (m.ExtraMonths != 0 || m.ExtraDays != 0)) {
                        m.NoFinancialDis = true;
                    }
                }
            }

            return m;
        })

        return membershipPackageProds;
    },
    MMBReturnProduct(index, product, booking) {
        return {
            ProductLineNo: index,
            ProductID: product.ProductID,
            Quantity: product.Quantity > 0 ? -Math.abs(product.Quantity) : Math.abs(product.Quantity),
            LinePriceExTax: product.ProductLinePriceExclTax > 0 ? -Math.abs(product.ProductLinePriceExclTax) : Math.abs(product.ProductLinePriceExclTax),
            LinePriceTax: product.ProductLineTaxTax > 0 ? -Math.abs(product.ProductLineTaxTax) : Math.abs(product.ProductLineTaxTax),
            LinePriceIncTax: product.ProductLinePriceInclTax > 0 ? -Math.abs(product.ProductLinePriceInclTax) : Math.abs(product.ProductLinePriceInclTax),
            LinePaidExTax: product.ProductLinePriceExclTax > 0 ? -Math.abs(product.ProductLinePriceExclTax) : Math.abs(product.ProductLinePriceExclTax),
            LinePaidTax: product.ProductLineTaxTax > 0 ? -Math.abs(product.ProductLineTaxTax) : Math.abs(product.ProductLineTaxTax),
            LinePaidIncTax: product.ProductLinePriceInclTax > 0 ? -Math.abs(product.ProductLinePriceInclTax) : Math.abs(product.ProductLinePriceInclTax),
            TourEventID: booking.TourEventID,
            TourProductID: product.TourProductID,
            CostRateID: product.CostRateID,
            BookingID: booking.BookingID
        };
    },
    MMBReturnUniqueProduct(index, product, booking, actualQty, remainingQty) {

        let prodLinePriceExTax = (Math.abs(product.ProductLinePriceExclTax / actualQty) * remainingQty);
        let prodLineLinePriceTax = (Math.abs(product.ProductLineTaxTax / actualQty) * remainingQty);
        let prodLineIncTax = (Math.abs(product.ProductLinePriceInclTax / actualQty) * remainingQty);

        return {
            ProductLineNo: index + 1,
            ProductID: product.ProductID,
            Quantity: -Math.abs(remainingQty),
            LinePriceExTax: -Math.abs(prodLinePriceExTax),
            LinePriceTax: -Math.abs(prodLineLinePriceTax),
            LinePriceIncTax: -Math.abs(prodLineIncTax),
            LinePaidExTax: -Math.abs(prodLinePriceExTax),
            LinePaidTax: -Math.abs(prodLineLinePriceTax),
            LinePaidIncTax: -Math.abs(prodLineIncTax),
            TourEventID: booking.TourEventID,
            TourProductID: product.TourProductID,
            CostRateID: product.CostRateID,
            BookingID: booking.BookingID
        };
    },
    MMBReturnUniqueCoupinNonItems(ReturnCouponAppliedQty, newp, product, couponProd, index, trans) {

        if (ReturnCouponAppliedQty > 0) {

            newp.LinePriceExTax = -(Math.abs(product.ProductLinePriceExclTax / Math.abs(product.Quantity)) * couponProd.TimesUsed);
            newp.LinePriceTax = -(Math.abs(product.ProductLineTaxTax / Math.abs(product.Quantity)) * couponProd.TimesUsed);
            newp.LinePriceIncTax = -(Math.abs(product.ProductLinePriceInclTax / Math.abs(product.Quantity)) * couponProd.TimesUsed);
            newp.LinePaidExTax = -(Math.abs(product.ProductLinePriceExclTax / Math.abs(product.Quantity)) * couponProd.TimesUsed);
            newp.LinePaidTax = -(Math.abs(product.ProductLineTaxTax / Math.abs(product.Quantity)) * couponProd.TimesUsed);
            newp.LinePaidIncTax = -(Math.abs(product.ProductLinePriceInclTax / Math.abs(product.Quantity)) * couponProd.TimesUsed);
            trans.Products.push(newp);

            if (ReturnCouponAppliedQty > 0) {

                let returnRemainingnUniProds = Object.assign({}, newp);

                returnRemainingnUniProds.LinePriceExTax = -(Math.abs(product.ProductLinePriceExclTax / Math.abs(product.Quantity)) * ReturnCouponAppliedQty);
                returnRemainingnUniProds.LinePriceTax = -(Math.abs(product.ProductLineTaxTax / Math.abs(product.Quantity)) * ReturnCouponAppliedQty);
                returnRemainingnUniProds.LinePriceIncTax = -(Math.abs(product.ProductLinePriceInclTax / Math.abs(product.Quantity)) * ReturnCouponAppliedQty);
                returnRemainingnUniProds.LinePaidExTax = -(Math.abs(product.ProductLinePriceExclTax / Math.abs(product.Quantity)) * ReturnCouponAppliedQty);
                returnRemainingnUniProds.LinePaidTax = -(Math.abs(product.ProductLineTaxTax / Math.abs(product.Quantity)) * ReturnCouponAppliedQty);
                returnRemainingnUniProds.LinePaidIncTax = -(Math.abs(product.ProductLinePriceInclTax / Math.abs(product.Quantity)) * ReturnCouponAppliedQty);
                returnRemainingnUniProds.ProductLineNo = index;
                returnRemainingnUniProds.Quantity = -Math.abs(ReturnCouponAppliedQty);
                returnRemainingnUniProds.CouponCodeApplied = null;
                trans.Products.push(returnRemainingnUniProds);
            }

        }
    },
    GetMMBModifyProduct(index, product, booking) {

        let LineExTax = Math.round((Math.abs((product.ProductLinePriceExclTax / (product.Quantity)) * (product.Quantity - product.newQuantity))) * 100) / 100;
        let LineTax = Math.round((Math.abs((product.ProductLineTaxTax / (product.Quantity)) * (product.Quantity - product.newQuantity))) * 100) / 100;
        let LineIncTax = Math.round((Math.abs((product.ProductLinePriceInclTax / (product.Quantity)) * (product.Quantity - product.newQuantity))) * 100) / 100;
        let ExTaxandTax = LineExTax + LineTax;

        if (ExTaxandTax !== LineIncTax && ((LineIncTax - ExTaxandTax) < 0)) {
            LineTax = LineTax - 0.01;
        }

        if (ExTaxandTax !== LineIncTax && ((LineIncTax - ExTaxandTax) > 0)) {
            LineTax = LineTax + 0.01;
        }

        return {
            ProductLineNo: index,
            ProductID: product.ProductID,
            Quantity: -Math.abs(product.Quantity - product.newQuantity),
            LinePriceExTax: -LineExTax,
            LinePriceTax: -LineTax,
            LinePriceIncTax: -LineIncTax,
            LinePaidExTax: -LineExTax,
            LinePaidTax: -LineTax,
            LinePaidIncTax: -LineIncTax,
            TourEventID: booking.TourEventID,
            TourProductID: product.TourProductID,
            CostRateID: product.CostRateID,
            BookingID: booking.BookingID,
            BookingStatus: "Modify Tickets"
        };
    },
    AddBookingUDFs(bookingUDFS, trans, newp, bkngID) {

        if (bookingUDFS && bookingUDFS.bookingUDFs.filter(x => x.BookingTypeID === bkngID).length > 0 && trans.Products.length >= 0) {
            let bkngUdfs = [];

            bookingUDFS.bookingUDFs.filter(x => x.BookingTypeID === bkngID).map(booking => {

                if (booking.UDFCategories && booking.UDFCategories.length > 0) {
                    booking.UDFCategories.map(udfCategories => {

                        if (udfCategories.UserDefinedFields && udfCategories.UserDefinedFields.length > 0) {
                            udfCategories.UserDefinedFields.filter(x => x.toureventID === newp.TourEventID && (x.Value.length > 0 || x.Value === true)).map(UDF => {

                                let val = UDF.UDFType !== "Bit" ? UDF.Value : UDF.Value === true ? 1 : 0;
                                let userdefine = { "UDFName": UDF.UDFName, "UDFValue": val };
                                bkngUdfs.push(userdefine);
                            });
                        }

                    });
                }


            });

            if (bkngUdfs && bkngUdfs.length > 0) {
                newp.BookingUDFs = bkngUdfs;
            }
        }
    },
    getOrderProductPrice(product) {
        return ShowOrderItemPriceAs.toLowerCase() == "inctax" ? product.PriceIncTax : product.PriceExTax
    },
    IsRequiredOptionsSelectedForOrderItem(Product) {
        if (Product.Options && Product.Options.length > 0) {
            return Product.Options.every(option => {
                if (option.IsRequired == false || option.Products.find(x => x.IsSelected) != undefined) {
                    return true;
                }
                else {
                    return false;
                }
            })
        } else {
            return true;
        }
    },
    getOrderProductsTotalPrice(foodproducts) {
        let amount = {
            price: 0,
            subtotal: 0,
            tax: 0,
            total: 0
        }
        if (foodproducts && foodproducts.length > 0) {
            foodproducts.forEach(p => {
                let pPriceIncTax = p.PriceIncTax;
                let pOptionPriceIncTax = 0;
                let pPriceExTax = p.PriceExTax;
                let pOptionPriceExTax = 0;
                let pPriceTax = p.PriceTax;
                let pOptionPriceTax = 0;

                if (p.Options && p.Options.length > 0) {
                    p.Options.forEach(option => {
                        if (option.Products && option.Products.length > 0) {
                            option.Products.filter(p => p.IsSelected).forEach(p => {
                                pOptionPriceIncTax += p.PriceIncTax;
                                pOptionPriceExTax += p.PriceExTax;
                                pOptionPriceTax += p.PriceTax;
                            });
                        }
                    });
                }
                amount.price += (pPriceExTax + pOptionPriceExTax);
                amount.subtotal += (pPriceExTax + pOptionPriceExTax) * p.Quantity;
                amount.tax += (pPriceTax + pOptionPriceTax) * p.Quantity;
                amount.total += (pPriceIncTax + pOptionPriceIncTax) * p.Quantity;
            });
        }
        return amount;
    },
    GetMembershipPackageFromApi(coupons, membershipID) {

        let membershipPackage = null;
        if (coupons && coupons.length > 0) {

            membershipPackage === null && coupons.map(coupon => {

                if (membershipPackage === null && coupon.MembershipPackages.filter(x => x.MembershipPackageID === membershipID).length > 0) {
                    membershipPackage = coupon.MembershipPackages.filter(x => x.MembershipPackageID === membershipID)[0];
                }
            });

            return membershipPackage;
        }
    },
    CalculateMultiMerchantTotal(events, gatickets, membershippackage, giftcards, donations, transactionfee, cashless, donationProducts, alternateTransactionfee) {

        let totalObj = {
            merchant1Total: 0,
            merchant2Total: 0
        };

        ///////////////////////// Merchant 1 Calculation /////////////////////////////////////

        if (events && events.length > 0) {

            events.filter(x => x.UseAlternateMerchant === false).map(e => {

                e.TourProducts.map(prods => {
                    totalObj.merchant1Total += this.IsNotFullPay(e.PaymentOption) ? prods.ProductSelectedTotalAmount : prods.ProductTotalAmount;
                });

                e.CouponItems.map(coupon => {
                    totalObj.merchant1Total -= coupon.TotalAmount;
                });
            });
        }

        if (gatickets && gatickets.length > 0) {
            totalObj.merchant1Total += gatickets.filter(x => x.UseAlternateMerchantOnline === false).map(({ TotalAmount }) => TotalAmount).reduce((sum, i) => sum + i, 0);
        }

        if (membershippackage && membershippackage.length > 0 && membershippackage[0].UseAlternateMerchant === false) {
            membershippackage[0].MembershipProducts.map(m => {
                if (m.hasOwnProperty('CouponCodeApplied') && m.CouponCodeApplied.length > 0) {
                    totalObj.merchant1Total += m.TotalAmountAfterCoupon ? m.TotalAmountAfterCoupon : 0;
                } 
                else {
                    if ((m.Users && m.Users.length > 0) || (m.MembershipType === 'AddOn')) {
                        if (m.MembershipType === 'AddOn') {
                            totalObj.merchant1Total += m.TotalAmount !== undefined ? m.TotalAmount : 0;
                        }
                         else {
                            totalObj.merchant1Total += m.TotalAmount !== undefined ? (m.TotalAmount * m.Users.length) : 0;
                        }
                    }
                }
            });
        }

        if (giftcards && giftcards.length > 0) {
            totalObj.merchant1Total += giftcards.filter(x => x.UseAlternateMerchantOnline === false).map(({ CartTotalAmount }) => CartTotalAmount).reduce((sum, i) => sum + i, 0);
        }

        if (donations && donations.hasOwnProperty('isdonationApplied') && donations.isdonationApplied && !donations.UseAlternateMerchantOnline) {
            totalObj.merchant1Total += parseFloat(donations.price);
        }

        if (donationProducts && donationProducts.length > 0) {
            totalObj.merchant1Total += donationProducts.filter(x => x.UseAlternateMerchantOnline === false).map(({ Amount }) => Amount).reduce((sum, i) => sum + i, 0);
        }

        ///////////////////////// Merchant 1 Calculation End ////////////////////////////////////


        ///////////////////////// Merchant 2 Calculation //////////////////////////////////////

        if (events && events.length > 0) {
            events.filter(x => x.UseAlternateMerchant === true).map(e => {

                e.TourProducts.map(prods => {
                    totalObj.merchant2Total += this.IsNotFullPay(e.PaymentOption) ? prods.ProductSelectedTotalAmount : prods.ProductTotalAmount;
                });

                e.CouponItems.map(coupon => {
                    totalObj.merchant2Total -= coupon.TotalAmount;
                });
            });
        }

        if (gatickets && gatickets.length > 0) {
            totalObj.merchant2Total += gatickets.filter(x => x.UseAlternateMerchantOnline === true).map(({ TotalAmount }) => TotalAmount).reduce((sum, i) => sum + i, 0);
        }

        if (membershippackage && membershippackage.length > 0 && membershippackage[0].UseAlternateMerchant === true) {

            membershippackage[0].MembershipProducts.map(m => {

                if (m.hasOwnProperty('CouponCodeApplied') && m.CouponCodeApplied.length > 0) {
                    totalObj.merchant2Total += m.TotalAmountAfterCoupon ? m.TotalAmountAfterCoupon : 0;
                } 
                else {
                    if ((m.Users && m.Users.length > 0) || (m.MembershipType === 'AddOn')) {
                        if (m.MembershipType === 'AddOn') {
                            totalObj.merchant2Total += m.TotalAmount !== undefined ? m.TotalAmount : 0;
                        } 
                        else {
                            totalObj.merchant2Total += m.TotalAmount !== undefined ? (m.TotalAmount * m.Users.length) : 0;
                        }
                    }
                }
            });
        }

        if (giftcards && giftcards.length > 0) {
            totalObj.merchant2Total += giftcards.filter(x => x.UseAlternateMerchantOnline === true).map(({ CartTotalAmount }) => CartTotalAmount).reduce((sum, i) => sum + i, 0);
        }

        if (donations && donations.hasOwnProperty('isdonationApplied') && donations.isdonationApplied && donations.UseAlternateMerchantOnline) {
            totalObj.merchant2Total += parseFloat(donations.price);
        }

        if (donationProducts && donationProducts.length > 0) {
            totalObj.merchant2Total += donationProducts.filter(x => x.UseAlternateMerchantOnline === true).map(({ Amount }) => Amount).reduce((sum, i) => sum + i, 0);
        }

        ///////////////////////// Merchant 2 Calculation End ////////////////////////////////////


        // ====== FEES ADDITION ======
        // Dual-merchant fee mode: compute per-merchant fees from each merchant's own base
        const dualFeesOn =EnableAlternateMerchantOnline &&
            transactionfee && transactionfee.hasOwnProperty('ProductID')
            alternateTransactionfee && alternateTransactionfee.hasOwnProperty('ProductID')

        if (dualFeesOn) {
            // compute and add fee to each merchant independently
            const m1FeeInc = this.calculateFeeIncludingTax(transactionfee, Math.max(0, totalObj.merchant1Total));
            const m2FeeInc = this.calculateFeeIncludingTax(alternateTransactionfee, Math.max(0, totalObj.merchant2Total));

            totalObj.merchant1Total = this.Rounded(totalObj.merchant1Total + m1FeeInc);
            totalObj.merchant2Total = this.Rounded(totalObj.merchant2Total + m2FeeInc);
        } 
        else {

            if (transactionfee && transactionfee.hasOwnProperty('ProductID') && transactionfee.UseAlternateMerchantOnline === false) {
                let transactionFee = genfunction.TransactionFee(
                    events, donations, transactionfee, cashless, membershippackage, gatickets, giftcards, null, donationProducts
                );
                if (transactionFee) {
                    totalObj.merchant1Total += Math.round(parseFloat(transactionFee) * 100) / 100;
                }
            }

            if (transactionfee && transactionfee.hasOwnProperty('ProductID') && transactionfee.UseAlternateMerchantOnline === true) {
                const transactionFee = genfunction.TransactionFee(
                    events, donations, transactionfee, cashless, membershippackage, gatickets, giftcards, null, donationProducts
                );
                if (transactionFee) {
                    totalObj.merchant2Total += Math.round(parseFloat(transactionFee) * 100) / 100;
                }
            }
        }

        ///////////////////////// Redeemed Giftcard Amount ////////////////////////////////////
        totalObj.merchant1Total = this.Rounded(totalObj.merchant1Total);
        totalObj.merchant2Total = this.Rounded(totalObj.merchant2Total);

        if (cashless && cashless.length > 0) {
            if (totalObj.merchant1Total > 0) {
                totalObj.merchant1Total -= cashless.map(({ HoldAmount }) => HoldAmount).reduce((sum, i) => sum + i, 0);
            }
            else if (totalObj.merchant2Total > 0) {
                totalObj.merchant2Total -= cashless.map(({ HoldAmount }) => HoldAmount).reduce((sum, i) => sum + i, 0);
            }

            if (totalObj.merchant1Total < 0) {
                totalObj.merchant2Total = totalObj.merchant2Total - Math.abs(totalObj.merchant1Total);
                totalObj.merchant1Total = 0;

                if (totalObj.merchant2Total < 0) {
                    totalObj.merchant2Total = 0;
                }
            }
        }
        ///////////////////////// Redeemed Giftcard End ////////////////////////////////////

        return totalObj;
    },
    CalculateEventFlexibleAmount(event, paymentOption, amountSelected) {

        event.PaymentOption = paymentOption;
        event.TotalSelectedAmount = amountSelected;

        event.TicketSelectedAmount = 0;
        event.TaxSelectedAmount = 0;

        if (event.PaymentOption === "FullPay") {
            event.TourProducts.forEach(product => {

                var itemp = product.ProductAmount;
                var itemtax = product.ProductTaxAmount;

                product.ProductSelectedAmount = itemp;
                product.ProductSelectedTaxAmount = itemtax;
                product.ProductSelectedTotalAmount = product.ProductSelectedAmount + product.ProductSelectedTaxAmount;

                event.TicketSelectedAmount += itemp;
                event.TaxSelectedAmount += itemtax;


            });
        }
        else if (event.PaymentOption === "MinimumPay") {
            event.TourProducts.forEach(product => {

                var itemp = (product.ProductAmount * product.MinDepositPercent) / 100;
                var itemtax = (product.ProductTaxAmount * product.MinDepositPercent) / 100;

                // itemp = Math.round(itemp * 100) / 100;
                // itemtax = Math.round(itemtax * 100) / 100;

                product.ProductSelectedAmount = Math.round(itemp * 100) / 100;
                product.ProductSelectedTaxAmount = Math.round(itemtax * 100) / 100;
                product.ProductSelectedTotalAmount = Math.round((itemp + itemtax) * 100) / 100;

                event.TicketSelectedAmount += Math.round(itemp * 100) / 100;;
                event.TaxSelectedAmount += Math.round(itemtax * 100) / 100;

            });
        }
        else if (event.PaymentOption === "OtherPay") {
            let remainingAmount = event.TotalSelectedAmount;
            event.TourProducts.forEach(product => {
                if (product.PriceMatrix && product.PriceMatrix.length > 0) {

                    var itemp = 0;
                    var itemtax = 0;
                    var itemTotalAmount = 0;

                    if (remainingAmount > product.ProductTotalAmount) {
                        itemTotalAmount = Math.round(product.ProductTotalAmount * 100) / 100;
                        remainingAmount -= itemTotalAmount;
                    }
                    else {
                        itemTotalAmount = Math.round(remainingAmount * 100) / 100;;
                        remainingAmount = 0;

                    }


                    product.PriceMatrix[0].Taxes.forEach(tax => {

                        itemp = Math.round((itemTotalAmount / ((tax.TaxPercentage / 100) + 1)) * 100) / 100;
                        itemtax = Math.round((itemTotalAmount - itemp) * 100) / 100;


                    });

                    product.ProductSelectedAmount = itemp;
                    product.ProductSelectedTaxAmount = itemtax;
                    product.ProductSelectedTotalAmount = itemTotalAmount;

                    event.TicketSelectedAmount += itemp;
                    event.TaxSelectedAmount += itemtax;

                }

            });
        }
        return event;
    },
    calculateFeeFromAmount(tFee, fixedBase, percentBase) {
        if (!tFee || tFee.Price <= 0) return 0;

        let fee = 0;

        if (!tFee.PriceIsAPercentage) {
            if (fixedBase > 0) {
                fee = parseFloat(tFee.Price);
            }
        }

        else {
            const base = percentBase || 0;
            fee = Math.round(parseFloat(base.toFixed(2)) * tFee.Price) / 100;
        }

        if (fee <= 0) return 0;

        if (tFee.Taxes && tFee.Taxes[0] && !tFee.Taxes[0].TaxIncluded) {
            fee += this.ApplyTransactionFeeTax(tFee, fee);
        }
        return fee;
    },


    GetProductsTotalPrice(products) {
        let amount = {
            subtotal: 0,
            tax: 0,
            total: 0
        }
        if (products && products.length > 0) {
            products.forEach(p => {

                amount.subtotal += this.IsNotFullPay(p.PaymentOption) ? p.TicketSelectedAmount : p.TicketAmount;
                amount.tax += this.IsNotFullPay(p.PaymentOption) ? p.TaxSelectedAmount : p.TaxAmount;
                amount.total += this.IsNotFullPay(p.PaymentOption) ? p.TotalSelectedAmount : p.TotalAmount;
            });
        }
        return amount;
    },

    IsNotNullOrEmptyOrUndefined(item) {
        return (item && item.toString().trim().length > 0 ? true : false);
    },

    IsEditEvent(bookingTypes, event) {

        const bookType = bookingTypes.filter(x => x.BookingTypeID === event.BookingTypeID)[0];

        if (bookType && (this.IsShowPartPaymentSelection(event, bookType) || bookType.ShowTourProductsBasedOnGroupSize)) {
            return true
        }
        return false;

    },

    IsOrganization(events) {

        if (events && events.length > 0) {
            let eventIndex = events.findIndex(x => x.OrganizationID && x.OrganizationID.toString().trim().length > 0);

            if (eventIndex >= 0)
                return true;

        }
        return false;
    },

    IsShowPartPaymentSelection(event, bkngType, groupSize) {

        let isShowPartPaymentSelection = false;

        if (bkngType.PayDepositOnly === false) {
            if (event && event.hasOwnProperty("TourProducts") && event.BookingTypeID === bkngType.BookingTypeID) {

                if (genfunction.IsNotFullPay(event.PaymentOption)) {
                    return true;
                }

                if (event.TourProducts.filter(p => p.AvailableOnline && p.PriceMatrix !== undefined && p.PriceMatrix.length > 0 && p.TourProductID !== bkngType.ChaperoneTourProductID).length > 0) {

                    event.TourProducts.filter(p => p.AvailableOnline && p.PriceMatrix !== undefined && p.PriceMatrix.length > 0 && p.TourProductID !== bkngType.ChaperoneTourProductID
                        && (this.IsNotNullOrEmptyOrUndefined(groupSize) && p.AffectsCapacity ? p.LimitDisplayOnGroupSize && p.GroupSize === groupSize : true))

                        .map((product) => {
                            if (product.MinDepositPercent >= 0.00 && product.MinDepositPercent < 100.00)
                                isShowPartPaymentSelection = true;
                        })
                }
            }
        }
        return isShowPartPaymentSelection;

    },

    IsNotFullPay(paymentOption) {
        return this.IsNotNullOrEmptyOrUndefined(paymentOption) && paymentOption !== "FullPay" ? true : false
    },
    IsNullOrUndefineReturnZero(amount) {
        return amount === undefined || amount === null || amount === '' ? 0 : amount
    },

    MinimumDepositCalculation(event, tourEventID, chaperoneTourProductID) {
        let MinDeposit = 0;

        if (event && event.hasOwnProperty("TourProducts") && event.TourEventID === tourEventID && event.TourProducts.filter(x => x.Quantity !== 0 && x.TourProductID !== chaperoneTourProductID).length > 0)
            event.TourProducts.filter(x => x.Quantity !== 0 && event.TourEventID === tourEventID && x.TourProductID !== chaperoneTourProductID).map((product) => {
                MinDeposit += (product.MinDepositPercent * product.ProductTotalAmount) / 100;
            })

        return Math.round(MinDeposit * 100) / 100;
    },

    CalculateAmountSelectedForMembers(events, bookingTypes) {

        events.forEach(event => {
            if (genfunction.IsNotFullPay(event.PaymentOption)) {

                if (event.PaymentOption === "MinimumPay") {

                    let ChaperoneTourProductID = bookingTypes && bookingTypes.length > 0 ? bookingTypes.filter(x => x.BookingTypeID === event.BookingTypeID)[0].ChaperoneTourProductID : null;
                    event.TotalSelectedAmount = this.MinimumDepositCalculation(event, event.TourEventID, ChaperoneTourProductID);

                }
                else if (event.PaymentOption === "OtherPay") {

                    event.OtherAmount = this.IsNotNullOrEmptyOrUndefined(event.OtherAmount) ? event.OtherAmount : event.TotalSelectedAmount;

                    let ChaperoneTourProductID = bookingTypes && bookingTypes.length > 0 ? bookingTypes.filter(x => x.BookingTypeID === event.BookingTypeID)[0].ChaperoneTourProductID : null;
                    let MinDeposit = this.MinimumDepositCalculation(event, event.TourEventID, ChaperoneTourProductID);

                    event.TotalSelectedAmount = event.TotalSelectedAmount >= event.TotalAmount ? event.TotalAmount :
                        (event.OtherAmount < MinDeposit ? MinDeposit : event.OtherAmount);

                }
                this.CalculateEventFlexibleAmount(event, event.PaymentOption, event.TotalSelectedAmount);
            }
        });
    },

    ConvertBookingtoTickets(transResponse, bookingID) {
        let index = 0;
        let bookingTickets = {};

        bookingTickets.BookingID = bookingID //transResponse[0].BookingID;
        bookingTickets.NodeNo = nodeNo;
        bookingTickets.ProcessType = "Ticket";
        bookingTickets.Tickets = [];

        transResponse[0].Products.filter(x => x.BookingReadyToTicket === true && x.UnitPriceIncTax >= 0 && x.BookingID == bookingID).forEach(tickets => {
            let newp = {
                TicketLineNo: index + 1,
                ProductID: tickets.ProductID,
                TourProductID: tickets.TourProductID,
                Quantity: tickets.Quantity,
                UnitPriceExTax: tickets.UnitPriceExTax,
                UnitPriceTax: tickets.UnitPriceTax,
                UnitPriceIncTax: tickets.UnitPriceIncTax,
            };

            bookingTickets.Tickets.push(newp);
            index++;
        });
        return bookingTickets;

    },

    AddCashlessAndAdditionalPayment(cashless, additionalPayment) {

        let cashlesstotal = 0;

        if (cashless && cashless.length > 0) {
            cashlesstotal = cashless ? cashless.map(({ HoldAmount }) => HoldAmount).reduce((sum, i) => sum + i, 0) : 0;
        }

        return this.Rounded(additionalPayment + cashlesstotal);
    },

    Rounded(value) {
        return Math.round(value * 100) / 100;
    },

    TransactionFeeForPartialPayment(transactionfee, enteredAmountToPay, cashlesstotal, useAlternateMerchant, alternateTransactionfee) {

        const dualFeesOn =EnableAlternateMerchantOnline && useAlternateMerchant &&
            transactionfee && transactionfee.hasOwnProperty('ProductID')
            alternateTransactionfee && alternateTransactionfee.hasOwnProperty('ProductID')

        if(dualFeesOn){
        let tFee = this.GetTransactionFeeForPartialPayment(alternateTransactionfee, enteredAmountToPay, cashlesstotal);

        if (tFee > 0 && (!alternateTransactionfee.Taxes[0].TaxIncluded)) {
            tFee += this.ApplyTransactionFeeTax(alternateTransactionfee, tFee);
        }

        return tFee;
        }
        else{
        let tFee = this.GetTransactionFeeForPartialPayment(transactionfee, enteredAmountToPay, cashlesstotal);

        if (tFee > 0 && (!transactionfee.Taxes[0].TaxIncluded)) {
            tFee += this.ApplyTransactionFeeTax(transactionfee, tFee);
        }

        return tFee;
        }
    },
    GetTransactionFeeForPartialPayment(transactionfee, enteredAmountToPay, cashlesstotal) {
        let transFee = 0;

        if (transactionfee && transactionfee.hasOwnProperty('ProductID')) {

            if (transactionfee.Price > 0) {
                if (!transactionfee.PriceIsAPercentage) {

                    transFee = ((enteredAmountToPay - cashlesstotal) || cashlesstotal > 0) ?
                        parseFloat(transactionfee.Price) : 0;

                }
                else {
                    transFee = this.Rounded((((enteredAmountToPay - cashlesstotal).toFixed(2)) * transactionfee.Price) / 100);
                }

                return transFee;
            }
        }

        return 0;

    },

    GetValueFromCountryAndState(countryandstates, country, columnName) {
        if (country != "" && countryandstates && countryandstates.length > 0 && countryandstates.filter(x => x.Country == country).length > 0) {
            return countryandstates.filter(x => x.Country == country)[0][columnName];
        }

        if (columnName === "PostalCodeName")
            return "ZIP Code";
        else if (columnName === "CityText")
            return "City";
        else if (columnName === "OrganizationText")
            return "Organization";
        else return true;

    },

    IsObjectNotNullOrEmptyOrUndefined(item) {
        return item !== null && item !== undefined && item.length > 0 ? true : false;

    },

    CalculateMultiMerchantTotalForMMB(event, cashless, transactionfee, enteredAmountToPay, bookings, alternateTransactionFee ) {
        let totalObj = {
            merchant1Total: 0,
            merchant2Total: 0
        };

        let payMultipleBookings = bookings && bookings.length > 1;

        bookings.map((booking) => {
            let isUseAlternateMerchant = booking && booking.hasOwnProperty('BookingID') ? booking.UseAlternateMerchant : null;

            ///////////////////////// Merchant 1 Calculation /////////////////////////////////////

            if ((this.IsObjectNotNullOrEmptyOrUndefined(event) && event[0].UseAlternateMerchant === false) || isUseAlternateMerchant === false) {

                totalObj.merchant1Total += payMultipleBookings ? booking.BalanceOwing : enteredAmountToPay;
            }

            ///////////////////////// Merchant 1 Calculation End ////////////////////////////////////

            ///////////////////////// Merchant 2 Calculation //////////////////////////////////////

            if ((this.IsObjectNotNullOrEmptyOrUndefined(event) && event[0].UseAlternateMerchant === true) || isUseAlternateMerchant === true) {

                totalObj.merchant2Total += payMultipleBookings ? booking.BalanceOwing : enteredAmountToPay;
            }

            ///////////////////////// Merchant 2 Calculation End ////////////////////////////////////

        })

        let cashlesstotal = cashless.map(({ HoldAmount }) => HoldAmount).reduce((sum, i) => sum + i, 0);


        // =====================================================================
        //                 NEW  --- DUAL MERCHANT FEE MODE
        // =====================================================================
        const dualFeesOn =EnableAlternateMerchantOnline &&
            transactionfee && transactionfee.hasOwnProperty('ProductID')
            alternateTransactionFee && alternateTransactionFee.hasOwnProperty('ProductID')

        if (dualFeesOn) {
            // >>> ADD fees separately <<< 
            const m1FeeInc = this.calculateFeeIncludingTax(transactionfee, totalObj.merchant1Total);
            const m2FeeInc = this.calculateFeeIncludingTax(alternateTransactionFee, totalObj.merchant2Total);

            totalObj.merchant1Total = this.Rounded(totalObj.merchant1Total + m1FeeInc);
            totalObj.merchant2Total = this.Rounded(totalObj.merchant2Total + m2FeeInc);
        }
        // =====================================================================
        //                 END DUAL MERCHANT FEE MODE
        // =====================================================================



        ///////////////////////// Merchant 1 Calculation For Transaction Fee /////////////////////////////////////

        // ORIGINAL LOGIC ??? NOW ONLY RUN IF dualFeesOn is false
        if (!dualFeesOn) {

            if (transactionfee && transactionfee.hasOwnProperty('ProductID') && transactionfee.UseAlternateMerchantOnline === false) {
                let transactionFee = genfunction.TransactionFeeForPartialPayment(transactionfee, enteredAmountToPay, cashlesstotal);
                if (transactionFee) {
                    totalObj.merchant1Total += this.Rounded(parseFloat(transactionFee));

                }
            }

            ///////////////////////// Merchant 1 Calculation End For Transaction Fee ////////////////////////////////////


            ///////////////////////// Merchant 2 Calculation For Transaction Fee //////////////////////////////////////

            if (transactionfee && transactionfee.hasOwnProperty('ProductID') && transactionfee.UseAlternateMerchantOnline === true) {

                let transactionFee = this.TransactionFeeForPartialPayment(transactionfee, enteredAmountToPay, cashlesstotal);
                if (transactionFee) {
                    totalObj.merchant2Total += this.Rounded(parseFloat(transactionFee));
                }
            }

            ///////////////////////// Merchant 2 Calculation End For Transaction Fee ////////////////////////////////////
        }



        ///////////////////////// Redeemed Giftcard Amount ////////////////////////////////////
        totalObj.merchant1Total = this.Rounded(totalObj.merchant1Total);
        totalObj.merchant2Total = this.Rounded(totalObj.merchant2Total);

        if (cashless && cashless.length > 0) {

            if (totalObj.merchant1Total > 0) {
                totalObj.merchant1Total -= cashless.map(({ HoldAmount }) => HoldAmount).reduce((sum, i) => sum + i, 0);
            }
            else if (totalObj.merchant2Total > 0) {
                totalObj.merchant2Total -= cashless.map(({ HoldAmount }) => HoldAmount).reduce((sum, i) => sum + i, 0);
            }



            if (totalObj.merchant1Total < 0) {

                totalObj.merchant2Total = totalObj.merchant2Total - Math.abs(totalObj.merchant1Total);
                totalObj.merchant1Total = 0;

                if (totalObj.merchant2Total < 0) {
                    totalObj.merchant2Total = 0;
                }
            }
        }

        ///////////////////////// Redeemed Giftcard End ////////////////////////////////////

        return totalObj;

    },
    calculateFeeIncludingTax(tFee, amount) {
        if (!tFee || tFee.Price <= 0 || amount <= 0) return 0;

        let exFee;

        if (!tFee.PriceIsAPercentage) {
            exFee = parseFloat(tFee.Price);
        }
        else {
            exFee = Math.round(parseFloat(amount.toFixed(2)) * tFee.Price) / 100;
        }
        if (exFee <= 0) return 0;

        if (tFee.Taxes && tFee.Taxes[0] && !tFee.Taxes[0].TaxIncluded) {
            return this.Rounded(exFee + this.ApplyTransactionFeeTax(tFee, exFee));
        }
        return this.Rounded(exFee);
    },
    UpdateMembershipPackageForRenewToNewMembershipPackage(membershipPackage, membermemberships, customer) {

        let memberpackageDetail = {
            membershipPackage: {},
            userslist: []
        }

        //Add Primary Member to the Primary Membership Type
        let count = 0;
        let primaryMemberMembership = membermemberships.Memberships && membermemberships.Memberships.length > 0 ? membermemberships.Memberships[0] : null;

        membershipPackage.MembershipProducts = membershipPackage.MembershipProducts.map(memType => {

            if (memType.MembershipType === "Membership" && count === 0) {
                memType.Users = [];

                var user = {
                    isPrimaryMember: true,
                    popupTitle: 'Primary Member',
                    firstName: membermemberships.FirstName,
                    lastName: membermemberships.LastName,
                    email: membermemberships.Email,
                    dob: this.GetValueIfObjectHasProperty('DateOfBirth', customer[0]),
                    phone: this.GetValueIfObjectHasProperty('MobilePhone', customer[0].CustomerAddress[0]),
                    address1: this.GetValueIfObjectHasProperty('Street1', customer[0].CustomerAddress[0]),
                    address2: this.GetValueIfObjectHasProperty('Street2', customer[0].CustomerAddress[0]),
                    city: this.GetValueIfObjectHasProperty('CitySuburb', customer[0].CustomerAddress[0]),
                    state: this.GetValueIfObjectHasProperty('State', customer[0].CustomerAddress[0]),
                    zipcode: this.GetValueIfObjectHasProperty('Postcode', customer[0].CustomerAddress[0]),
                    country: this.GetValueIfObjectHasProperty('Country', customer[0].CustomerAddress[0]),
                    userNo: membermemberships.MemberNumber,
                    isRenewal: true,
                    isEdit: false,
                    membershipTypeID: memType.MembershipTypeID,
                    membershipTypeName: memType.ProductName,
                    PreviousMembershipType: primaryMemberMembership.ProductName,
                    notpartofPackage: false,
                    UniquePackageRef: primaryMemberMembership.UniquePackageRef,
                    MembershipExpiryDate: primaryMemberMembership.MembershipExpiryDate,
                    userSelectedFromDropdown: true
                }

                memType.Users.push(user);
                count++;
            }

            return memType;
        })

        //Add Other Family Members

        if (membermemberships && membermemberships.LinkedIndividuals && membermemberships.LinkedIndividuals.length > 0) {

            membermemberships.LinkedIndividuals.map(mem => {

                var linkedUser = customer[0].LinkedIndividuals.filter(x => x.CustomerID == mem.MemberNumber);

                if (linkedUser && linkedUser.length > 0) {
                    var user = {
                        isPrimaryMember: false,
                        firstName: mem.FirstName,
                        lastName: mem.LastName,
                        email: linkedUser[0].hasOwnProperty('Email') ? linkedUser[0].Email : '',
                        dob: mem.DateOfBirth === undefined || mem.DateOfBirth === '' ? null : mem.DateOfBirth,
                        phone: linkedUser[0].hasOwnProperty('MobilePhone') ? linkedUser[0].MobilePhone : '',
                        address1: '',
                        address2: '',
                        city: '',
                        state: '',
                        zipcode: '',
                        country: '',
                        userNo: mem.MemberNumber,
                        membershipTypeID: 0,
                        membershipTypeName: '',
                        previousMembershipType: '',
                        notpartofPackage: true,
                        isRenewal: true,
                        isEdit: false,
                        UniquePackageRef: '',
                        MembershipExpiryDate: '',
                        userSelectedFromDropdown: false
                    }

                    memberpackageDetail.userslist.push(user);
                }

            });
        }

        memberpackageDetail.membershipPackage = membershipPackage;
        return memberpackageDetail;
    },
    GetSecondaryUserAddressID(user, customerAddresses) {

        let addressID = 0;

        if (user && customerAddresses && customerAddresses.length > 0) {

            let customer = customerAddresses.filter(x => x.CustomerID === user.userNo)[0];

            if (customer) {
                let userAdd = customer.CustomerAddress.filter(x => x.AddressTypeID === StreetAddressTypeID)[0];

                if (userAdd) {
                    addressID = userAdd.AddressID;
                }
            }
        }

        return addressID;
    }, GetPrimaryMemberMembershipStartDate(membershipPackages) {
        let primaryMemberRenewStartDate = "";

        membershipPackages.forEach(memPack => {

            memPack.MembershipProducts.filter(x => x.MembershipType === "Membership").forEach(m => {

                if (m.MembershipType === "Membership" && m.Users.length > 0) {
                    m.Users.forEach(u => {

                        if (u.isPrimaryMember) {
                            primaryMemberRenewStartDate = u.startDate
                        }
                    });
                }

            });

        });

        return primaryMemberRenewStartDate;
    },

    IsArrayNotEmptyNullUndefined(array) {

        return array && Array.isArray(array) && array.length > 0;
    },

    IsExternalUrl(url) {

        return /^https?:\/\//.test(url);
    },

  ShouldTrackPurchase(refundType) {
    return !refundType;
  },

  BuildPurchaseTrackingPayload(transaction) {
    const amounts = this.GetTotalAmount(transaction.Products);

    const items = transaction.Products
      .filter(product => product.Quantity > 0)
      .map(product => ({
        id: product.ProductID,
        name: product.ProductName,
        quantity: product.Quantity,
        price: product.LinePaidIncTax / product.Quantity
      }));

    return {
      transactionId: transaction.ReceiptNo,
      customerId: transaction.CustomerID,
      value: amounts.totalInclTax,
      tax: amounts.totalTax,
      currency: window['runConfig'].CurrencyCode,
      items: items
    };
  }

}

